export const en = {
  "dashboard-bi::edit-report::click_or_drop_dimension": "Dragging or double click here dimension field",
  "dashboard-bi::edit-report::drill": "Drill",
  "account_binging_shop_exist_error": "The advertising account has been bound shops",
  "account_binging_shop_exist_repeat": "Advertising and repeat bind shop",
  "ACCOUNT_DISABLE": "Account has been frozen2",
  "account_exist_error": "Advertising account already exists",
  "account_insert_fail": "Failed to add account",
  "ACCOUNT_IS_EXPIRE": "Your package has expired! Go to renewal",
  "account_name_is_exist": "paypal account referred to already exists",
  "account_not_exit": "Advertising account does not exist or has expired",
  "ACCOUNT_NUMBER_ALREADY_EXIST": "Account id is already registered, please replace the account",
  "ACCOUNT_STATUS_DISABLE": "Account is frozen, please contact the administrator",
  "account_update_fail": "Account update failed",
  "accountid_is_disable": "The accountId has been disabled",
  "ACTION_CODE_EXIST": "Resource code already exists",
  "ACTION_PERM_NOT_EXIST": "Menu resource does not exist",
  "ad_insights_query_error": "Advertising report query fails",
  "ad-analysis::adAccount": "Advertising account",
  "ad-analysis::adGroup": "Ad Group",
  "ad-analysis::adName": "advertising",
  "ad-analysis::adSeries": "Campaign",
  "ad-analysis::auth_tooltip": "You can set up your account analysis presented [ad]",
  "ad-analysis::cost_title": "Advertising spending",
  "ad-analysis::cost_tooltip": "The total cost of advertising",
  "ad-analysis::date": "date",
  "ad-analysis::placeholder_account": "Please select the ad account",
  "ad-analysis::placeholder_data": "Please select the data index",
  "ad-analysis::placeholder_shop": "Please select a store",
  "ad-analysis::placeholder_type": "Please select a campaign",
  "ad-analysis::roi_tooltip": "The formula: the amount of advertising sales / advertising costs,<br /> Statistics Ad Type:",
  "ad-analysis::sales_title": "Advertising sales",
  "ad-analysis::sales_tooltip": "Advertising revenue",
  "ad-analysis::tab_all": "Complete",
  "ad-analysis::table_addBuy": "Plus the amount purchased",
  "ad-analysis::table_addBuyCost": "Plus purchase costs",
  "ad-analysis::table_clickNum": "Traffic",
  "ad-analysis::table_clickRate": "Click to rate",
  "ad-analysis::table_count": "Launch checkout amount",
  "ad-analysis::table_countCost": "Launch checkout amount",
  "ad-analysis::table_coverNum": "Reach",
  "ad-analysis::table_adcost": "Advertising spending",
  "ad-analysis::table_order": "number of order",
  "ad-analysis::table_sales": "Sales Amount",
  "ad-analysis::table_shopName": "Store Name",
  "ad-analysis::table_transCost": "The average conversion costs",
  "ad-analysis::table_transRate": "Payment conversion",
  "ADMIN_PARAM_FAIL": "Parameter error, please check the parameters",
  "ADMIN_USER_DISABLE": "The user has been disabled, can not log management system",
  "ADMIN_USER_NOT_FOUND": "The system is not synchronized current employees account information, please contact your administrator",
  "ADMIN_USER_TOKEN_INVALID": "User token has expired",
  "ADMIN_VERIFY_JWT_ERROR": "User token verification fails, verify that the token is correct",
  "after-sales::after-sale-list::add_after_sales_order": "New single sale",
  "after-sales::after-sale-list::after_sale_reason": "Reason for sale",
  "after-sales::after-sale-list::after_sale_source": "Sources sale",
  "after-sales::after-sale-list::after_sales_number": "No single sale",
  "after-sales::after-sale-list::applicant": "applicant",
  "after-sales::after-sale-list::application_time": "application time",
  "after-sales::after-sale-list::batch_application": "Batch Application",
  "after-sales::after-sale-list::batch_refund": "Batch Refund",
  "after-sales::after-sale-list::detail_after_sale_type": "Sale type",
  "after-sales::after-sale-list::detail_applicant": "applicant",
  "after-sales::after-sale-list::detail_application_time": "application time",
  "after-sales::after-sale-list::detail_apply_refund": "Request a refund",
  "after-sales::after-sale-list::detail_apply_refund_success": "Refund success",
  "after-sales::after-sale-list::detail_attachment": "annex",
  "after-sales::after-sale-list::detail_audit_time": "Review time",
  "after-sales::after-sale-list::detail_auditor": "Reviewer",
  "after-sales::after-sale-list::detail_auto_refund_warning": "After the refund system will connect the platform automatically refund!",
  "after-sales::after-sale-list::detail_btn_cancel": "cancel",
  "after-sales::after-sale-list::detail_btn_confirm": "determine",
  "after-sales::after-sale-list::detail_download": "download",
  "after-sales::after-sale-list::detail_email": "Email",
  "after-sales::after-sale-list::detail_fulfillment_status": "Delivery status",
  "after-sales::after-sale-list::detail_order_correct": "Please enter a valid order number",
  "after-sales::after-sale-list::detail_order_create_success": "Generate a single sale success",
  "after-sales::after-sale-list::detail_order_info": "Sale order information",
  "after-sales::after-sale-list::detail_order_num": "order number",
  "after-sales::after-sale-list::detail_order_price_tips": "Can only refund {amount}",
  "after-sales::after-sale-list::detail_order_refund_tips": "Free refund could only retreat {amount}",
  "after-sales::after-sale-list::detail_order_select": "Please select a sub-orders",
  "after-sales::after-sale-list::detail_order_update_success": "Modify single successful sale",
  "after-sales::after-sale-list::detail_please_select": "Choose Order",
  "after-sales::after-sale-list::detail_refund": "Refund",
  "after-sales::after-sale-list::detail_refund_apply_tips": "Determining a refund the following aftermarket orders it",
  "after-sales::after-sale-list::detail_refund_confirm_tips": "Submit the application to determine the refund?",
  "after-sales::after-sale-list::detail_refund_currency": "Refund currency",
  "after-sales::after-sale-list::detail_refund_reason": "Reason for sale",
  "after-sales::after-sale-list::detail_refund_success": "Refund successfully",
  "after-sales::after-sale-list::detail_refund_time": "Refund Time",
  "after-sales::after-sale-list::detail_refund_weather": "Sure you want to refund",
  "after-sales::after-sale-list::detail_reject": "turn down",
  "after-sales::after-sale-list::detail_reject_success": "Success dismissed",
  "after-sales::after-sale-list::detail_remark": "Remark",
  "after-sales::after-sale-list::detail_return": "return",
  "after-sales::after-sale-list::detail_sales_order_num": "No single sale",
  "after-sales::after-sale-list::detail_sales_order_refund_weather": "Determine refunds following sale orders it",
  "after-sales::after-sale-list::detail_sales_resource": "Sources sale",
  "after-sales::after-sale-list::detail_shop": "Shop",
  "after-sales::after-sale-list::detail_shop_order_num": "Shop Order Number",
  "after-sales::after-sale-list::detail_table_after_sale_count": "Number of sale",
  "after-sales::after-sale-list::detail_table_buy_count": "Purchase quantity",
  "after-sales::after-sale-list::detail_table_discount": "Preferential",
  "after-sales::after-sale-list::detail_table_email_price": "Free",
  "after-sales::after-sale-list::detail_table_fullfill_status": "Delivery status",
  "after-sales::after-sale-list::detail_table_has_sales": "There sale",
  "after-sales::after-sale-list::detail_table_no_sales": "No sale",
  "after-sales::after-sale-list::detail_table_price": "unit price",
  "after-sales::after-sale-list::detail_table_refund": "Refund",
  "after-sales::after-sale-list::detail_table_refund_email": "Refund Shipping",
  "after-sales::after-sale-list::detail_table_sales_total": "The total sale amount",
  "after-sales::after-sale-list::detail_table_shop": "commodity",
  "after-sales::after-sale-list::detail_table_status": "status",
  "after-sales::after-sale-list::detail_table_sub_order": "Child order",
  "after-sales::after-sale-list::detail_table_total": "Subtotal",
  "after-sales::after-sale-list::detail_update": "modify",
  "after-sales::after-sale-list::detail_warning_tips": "After submitting the application can not modify the order message!",
  "after-sales::after-sale-list::email": "Email",
  "after-sales::after-sale-list::export": "Export",
  "after-sales::after-sale-list::label_payment_channel": "Payment channels",
  "after-sales::after-sale-list::label_platform": "platform",
  "after-sales::after-sale-list::label_shop": "Shop",
  "after-sales::after-sale-list::new_after_sale_amount": "The total sale amount",
  "after-sales::after-sale-list::new_after_sale_type": "Sale type",
  "after-sales::after-sale-list::new_after_sale_type_holder": "Please select the type of sale",
  "after-sales::after-sale-list::new_back_order": "Return after-sale orders",
  "after-sales::after-sale-list::new_bill_attachement": "annex",
  "after-sales::after-sale-list::new_bill_num": "account number",
  "after-sales::after-sale-list::new_bill_num_holder": "Please enter the bill number",
  "after-sales::after-sale-list::new_order_info": "Sale order information",
  "after-sales::after-sale-list::new_order_num": "order number",
  "after-sales::after-sale-list::new_order_num_holder": "Please enter your order number",
  "after-sales::after-sale-list::new_placeholder": "Please enter content",
  "after-sales::after-sale-list::new_reason": "Reason for sale",
  "after-sales::after-sale-list::new_refund": "Refund type",
  "after-sales::after-sale-list::new_refund_holder": "Please select the type of refund",
  "after-sales::after-sale-list::new_refund_reason_holder": "Please select the reason for sale",
  "after-sales::after-sale-list::new_refund_source_holder": "Please select aftermarket sources",
  "after-sales::after-sale-list::new_remark": "Remark",
  "after-sales::after-sale-list::new_responsible_party": "Responsible party",
  "after-sales::after-sale-list::new_return": "return",
  "after-sales::after-sale-list::new_save": "save",
  "after-sales::after-sale-list::new_select_amount": "By Amount",
  "after-sales::after-sale-list::new_select_proportion": "In proportion",
  "after-sales::after-sale-list::new_shop_order_num": "Shop Order Number",
  "after-sales::after-sale-list::new_shop_order_num_holder": "Please enter a shop order number",
  "after-sales::after-sale-list::new_source": "Sources sale",
  "after-sales::after-sale-list::new_table_amount": "Refund",
  "after-sales::after-sale-list::new_table_buy_amount": "Purchase quantity",
  "after-sales::after-sale-list::new_table_discount": "Preferential",
  "after-sales::after-sale-list::new_table_fulfillment_status": "Delivery status",
  "after-sales::after-sale-list::new_table_pay_amount": "Subtotal",
  "after-sales::after-sale-list::new_table_pay_ship_amount": "Free",
  "after-sales::after-sale-list::new_table_refund_quantity": "Number of sale",
  "after-sales::after-sale-list::new_table_refund_ship_amount": "Refund Shipping",
  "after-sales::after-sale-list::new_table_shop": "commodity",
  "after-sales::after-sale-list::new_table_single_price": "unit price",
  "after-sales::after-sale-list::new_table_sub_order": "Child order",
  "after-sales::after-sale-list::new_type_off_internet": "No Internet",
  "after-sales::after-sale-list::new_type_part_ship": "Section delivery",
  "after-sales::after-sale-list::new_type_part_shiped": "Shipped",
  "after-sales::after-sale-list::new_type_part_sign": "Section sign",
  "after-sales::after-sale-list::new_type_refunding": "In return",
  "after-sales::after-sale-list::new_type_signed": "Have been received",
  "after-sales::after-sale-list::new_type_wait_handle": "Pending",
  "after-sales::after-sale-list::new_type_wait_ship": "to be delivered",
  "after-sales::after-sale-list::order_number": "order number",
  "after-sales::after-sale-list::pending_refund": "Be refunded",
  "after-sales::after-sale-list::quick_sort": "Rapid screening",
  "after-sales::after-sale-list::refund_type": "Refund type",
  "after-sales::after-sale-list::refunded": "refunded",
  "after-sales::after-sale-list::rejected": "Rejected",
  "after-sales::after-sale-list::responsible_party": "Responsible party",
  "after-sales::after-sale-list::select_closed": "closed",
  "after-sales::after-sale-list::select_has_redunded": "refunded",
  "after-sales::after-sale-list::select_reject": "Rejected",
  "after-sales::after-sale-list::select_unpay": "unpaid",
  "after-sales::after-sale-list::select_wait": "Pending application",
  "after-sales::after-sale-list::select_wait_refund": "Be refunded",
  "after-sales::after-sale-list::sku": "SKU",
  "after-sales::after-sale-list::spu": "SPU",
  "after-sales::after-sale-list::tab_has_application": "Already applied",
  "after-sales::after-sale-list::tab_has_close": "closed",
  "after-sales::after-sale-list::tab_pending_application": "Pending application",
  "after-sales::after-sale-list::table_after_sale_order_num": "No single sale",
  "after-sales::after-sale-list::table_application_time": "application time",
  "after-sales::after-sale-list::table_apply_refund": "Request a refund",
  "after-sales::after-sale-list::table_close_order": "Closing the Ticket",
  "after-sales::after-sale-list::table_commodity": "commodity",
  "after-sales::after-sale-list::table_detail": "Detail",
  "after-sales::after-sale-list::table_edit": "edit",
  "after-sales::after-sale-list::table_email": "Email",
  "after-sales::after-sale-list::table_go_bind": "Go Bind",
  "after-sales::after-sale-list::table_go_bind_tips": "Paypal account is not bound to pay, after binding a key to a refund",
  "after-sales::after-sale-list::table_opt": "operating",
  "after-sales::after-sale-list::table_order_num": "order number",
  "after-sales::after-sale-list::table_pay_channel": "Payment channels",
  "after-sales::after-sale-list::table_re_applicate": "Re-apply",
  "after-sales::after-sale-list::table_refund": "Refund",
  "after-sales::after-sale-list::table_reject": "turn down",
  "after-sales::after-sale-list::table_remark": "Remark",
  "after-sales::after-sale-list::table_sales_price": "Sale amount",
  "after-sales::after-sale-list::table_sales_reason": "Reason for sale",
  "after-sales::after-sale-list::table_shop": "Shop",
  "after-sales::after-sale-list::table_status": "status",
  "after-sales::after-sale-list::table_type": "Types of",
  "after-sales::after-sale-list::transaction_num": "Trading serial number",
  "after-sales::after-sales-set::add_cancel": "cancel",
  "after-sales::after-sales-set::add_reason": "New reasons for sale",
  "after-sales::after-sales-set::add_reason_add_edit": "Editing sale reason",
  "after-sales::after-sales-set::add_reason_add_sub": "Add sub",
  "after-sales::after-sales-set::add_reason_parent_cate": "Parent directory",
  "after-sales::after-sales-set::add_reason_type": "Reason for sale",
  "after-sales::after-sales-set::add_responsible_party": "Responsible party",
  "after-sales::after-sales-set::add_responsible_party_holder": "Please select the responsible party",
  "after-sales::after-sales-set::add_save": "save",
  "after-sales::after-sales-set::after_sales_reason": "Reason for sale",
  "after-sales::after-sales-set::after_sales_reason_add": "New reasons for sale",
  "after-sales::after-sales-set::after_sales_setting": "Sale type",
  "after-sales::after-sales-set::after_sales_source": "Sources sale",
  "after-sales::after-sales-set::after_sales_source_add": "Adding aftermarket sources",
  "after-sales::after-sales-set::delete": "delete",
  "after-sales::after-sales-set::input_name_holder": "Please enter a name",
  "after-sales::after-sales-set::move": "mobile",
  "after-sales::after-sales-set::reason": "Reason for sale",
  "after-sales::after-sales-set::reason_add_sub": "Add sub",
  "after-sales::after-sales-set::reason_cancel": "cancel",
  "after-sales::after-sales-set::reason_cate_name": "Category Name",
  "after-sales::after-sales-set::reason_confirm": "determine",
  "after-sales::after-sales-set::reason_delete": "delete",
  "after-sales::after-sales-set::reason_delete_title": "Confirm delete?",
  "after-sales::after-sales-set::reason_delete_warn": "After deleting the data can not be recovered",
  "after-sales::after-sales-set::reason_edit": "edit",
  "after-sales::after-sales-set::reason_opt": "operating",
  "after-sales::after-sales-set::reason_responsible_party": "Responsible party",
  "after-sales::after-sales-set::refund_type": "Refund type",
  "after-sales::after-sales-set::refund_type_add": "Add Refund type",
  "after-sales::after-sales-set::responsible_party_add": "Add the responsible party",
  "after-sales::after-sales-set::setting_add": "Adding sale type",
  "after-sales::after-sales-set::setting_default_tips": "The default parameters can not be edited drag, please add their own custom parameters",
  "after-sales::after-sales-set::setting_default_tips_red": "Add, edit, or drag after click [Save] to take effect",
  "after-sales::after-sales-set::setting_tag_name": "Label name",
  "after-sales::email-setting::email_sort": "Mail Classification",
  "after-sales::email-setting::email_sort_add": "add category",
  "after-sales::email-setting::email_tag": "Mailing Labels",
  "after-sales::email-setting::email_tag_add": "New Label",
  "after-sales::email-setting::email_tag_add_add_sub": "Add sub tag",
  "after-sales::email-setting::email_tag_add_cancel": "cancel",
  "after-sales::email-setting::email_tag_add_confirm": "determine",
  "after-sales::email-setting::email_tag_add_edit": "Edit Labels",
  "after-sales::email-setting::email_tag_add_parent_cate": "Parent Category",
  "after-sales::email-setting::email_tag_add_save": "save",
  "after-sales::email-setting::email_tag_add_sub": "Add sub",
  "after-sales::email-setting::email_tag_color": "Label Color",
  "after-sales::email-setting::email_tag_delete": "delete",
  "after-sales::email-setting::email_tag_delete_confirm": "Confirm to delete the label?",
  "after-sales::email-setting::email_tag_delete_tip": "After deleting the data can not be recovered",
  "after-sales::email-setting::email_tag_edit": "edit",
  "after-sales::email-setting::email_tag_name": "Label name",
  "after-sales::email-setting::email_tag_name_holder": "Please enter the label name",
  "after-sales::email-setting::email_tag_opt": "operating",
  "after-sales::email-setting::empty_bind_email": "Immediately set",
  "after-sales::email-setting::empty_email_tips": "After binding the mailbox, customers can send and receive e-mail, the connection service, EDM marketing",
  "after-sales::email-setting::empty_email_title": "You have not set customer service email",
  "after-sales::email-setting::please_inpu_after": "Please enter a reason sale",
  "after-sales::email-setting::please_input": "please enter",
  "after-sales::email-setting::please_input_cate": "Enter the parent category",
  "after-sales::email-setting::please_input_color": "Please enter the label color",
  "after-sales::email-setting::please_input_tag_parent": "Please select the parent tag",
  "after-sales::email-setting::please_select_duty": "Please select the responsible party",
  "after-sales::in-box::add_sort": "New Category",
  "after-sales::in-box::add_sort_new": "add category",
  "after-sales::in-box::add_tag": "New Label",
  "after-sales::in-box::after_sale_status": "Aftermarket state",
  "after-sales::in-box::attachment": "annex",
  "after-sales::in-box::bcc": "BCC",
  "after-sales::in-box::bind_in_box": "Binding mailbox",
  "after-sales::in-box::btn_cancel": "cancel",
  "after-sales::in-box::btn_send": "send",
  "after-sales::in-box::can_not_info": "Users can not obtain order information",
  "after-sales::in-box::content": "text",
  "after-sales::in-box::content_placeholder": "Please enter text",
  "after-sales::in-box::country": "country",
  "after-sales::in-box::detail_classify": "Classify",
  "after-sales::in-box::detail_copy_content": "Copy the contents of the message",
  "after-sales::in-box::detail_email_id": "Mail ID",
  "after-sales::in-box::detail_handler": "principal",
  "after-sales::in-box::detail_mark_as": "Mark as",
  "after-sales::in-box::detail_recipient": "Addressee",
  "after-sales::in-box::detail_remark": "Remark",
  "after-sales::in-box::detail_remark_holder": "Please enter comments",
  "after-sales::in-box::detail_remark_placeholder": "Please enter comments (optional)",
  "after-sales::in-box::detail_replier": "Reply people",
  "after-sales::in-box::detail_reply": "Reply",
  "after-sales::in-box::detail_reply_time": "Response Time",
  "after-sales::in-box::detail_send_time": "Send Time",
  "after-sales::in-box::detail_sender": "Sender",
  "after-sales::in-box::detail_sort": "classification",
  "after-sales::in-box::detail_status": "status",
  "after-sales::in-box::email": "Outgoing mail",
  "after-sales::in-box::email_content": "Message Body",
  "after-sales::in-box::email_detail": "Mail Details",
  "after-sales::in-box::email_id": "Mail ID",
  "after-sales::in-box::email_sort": "Mail Classification",
  "after-sales::in-box::email_tag": "Mailing Labels",
  "after-sales::in-box::email_topic": "Email Subject",
  "after-sales::in-box::empty_tips": "Here you can send and receive e-mail customer contacts, and efficient after-sales service",
  "after-sales::in-box::empty_title": "Manage your inbox",
  "after-sales::in-box::handler": "principal",
  "after-sales::in-box::history_bind": "Captive customer",
  "after-sales::in-box::history_bind_customer": "Captive customer",
  "after-sales::in-box::history_bind_info": "After that message captive customer, bindings show the customer order history",
  "after-sales::in-box::history_btn_cancel": "cancel",
  "after-sales::in-box::history_btn_confirm": "determine",
  "after-sales::in-box::history_check": "View",
  "after-sales::in-box::history_correct_holder": "Please enter a valid email",
  "after-sales::in-box::history_country": "country",
  "after-sales::in-box::history_email": "mailbox",
  "after-sales::in-box::history_email_usage": "Or use a mailbox",
  "after-sales::in-box::history_logistics_status": "Logistics state",
  "after-sales::in-box::history_opt": "operating",
  "after-sales::in-box::history_order": "Order History",
  "after-sales::in-box::history_order_email": "Single mailbox",
  "after-sales::in-box::history_order_email_holder": "Please enter a single email",
  "after-sales::in-box::history_order_num": "order number",
  "after-sales::in-box::history_order_num_holder": "Please enter your order number",
  "after-sales::in-box::history_order_tips": "Tip: to support the system the message is bound to orders by customers have placed orders or mail order number",
  "after-sales::in-box::history_ordernum_usage": "Or use the order number",
  "after-sales::in-box::history_pay_bill": "Payment amount",
  "after-sales::in-box::history_pay_time": "Payment time",
  "after-sales::in-box::history_payment_status": "Payment status",
  "after-sales::in-box::history_sell_status": "Aftermarket state",
  "after-sales::in-box::history_sku": "SKU",
  "after-sales::in-box::in_out_mail": "Incoming and outgoing mail",
  "after-sales::in-box::in_out_mail_customer_send": "Customer issue",
  "after-sales::in-box::in_out_mail_delete": "successfully deleted",
  "after-sales::in-box::in_out_mail_deliver_time": "Transceiver time",
  "after-sales::in-box::in_out_mail_detail": "Detail",
  "after-sales::in-box::in_out_mail_handler": "principal",
  "after-sales::in-box::in_out_mail_mark": "Mark as",
  "after-sales::in-box::in_out_mail_num": "Numbering",
  "after-sales::in-box::in_out_mail_opt": "operating",
  "after-sales::in-box::in_out_mail_opt_success": "Successful operation",
  "after-sales::in-box::in_out_mail_reply": "Reply",
  "after-sales::in-box::in_out_mail_reply_letter": "reply",
  "after-sales::in-box::in_out_mail_select_mail": "Please select the mail",
  "after-sales::in-box::in_out_mail_send_email": "send email",
  "after-sales::in-box::in_out_mail_shop": "Shop",
  "after-sales::in-box::in_out_mail_sort": "Mail Classification",
  "after-sales::in-box::in_out_mail_subject": "Email Subject",
  "after-sales::in-box::in_out_mail_tag": "E-mail label",
  "after-sales::in-box::in_out_mail_user_send": "Customer service issue",
  "after-sales::in-box::include": "contain",
  "after-sales::in-box::input_receiver_input": "Please enter the recipient",
  "after-sales::in-box::input_subject_input": "Please enter a subject",
  "after-sales::in-box::logistics_number": "Logistics No.",
  "after-sales::in-box::logistics_online_status": "Logistics online status",
  "after-sales::in-box::mark_as": "Mark as",
  "after-sales::in-box::no_reply": "Unanswered",
  "after-sales::in-box::no_user_info": "No user order information",
  "after-sales::in-box::not_include": "Does not contain",
  "after-sales::in-box::order_detail": "order details",
  "after-sales::in-box::order_number": "order number",
  "after-sales::in-box::order_status": "Order Status",
  "after-sales::in-box::payment_date": "Payment time",
  "after-sales::in-box::payment_serial_number": "Serial number paid",
  "after-sales::in-box::payment_status": "Payment status",
  "after-sales::in-box::please_select": "please choose",
  "after-sales::in-box::reassign": "Reassignment",
  "after-sales::in-box::receive_amount": "Write the number",
  "after-sales::in-box::receiving_time": "Write time",
  "after-sales::in-box::recipient": "Addressee",
  "after-sales::in-box::remark": "Remark",
  "after-sales::in-box::reply_letter": "reply",
  "after-sales::in-box::responder": "Reply people",
  "after-sales::in-box::response_date": "Response Time",
  "after-sales::in-box::select_all": "Complete",
  "after-sales::in-box::select_receiver_input": "Please select the sender",
  "after-sales::in-box::send_date": "Send Time",
  "after-sales::in-box::sender": "Sender",
  "after-sales::in-box::shop": "Shop",
  "after-sales::in-box::shop_order_number": "Shop Order Number",
  "after-sales::in-box::sort": "Classify",
  "after-sales::in-box::sort_name": "Category Name",
  "after-sales::in-box::sort_name_input": "Please enter the category name",
  "after-sales::in-box::subject": "theme",
  "after-sales::in-box::tab_all": "Complete",
  "after-sales::in-box::tab_replied": "Replied",
  "after-sales::in-box::tab_unanswered": "Unanswered",
  "after-sales::in-box::table_detail": "Detail",
  "after-sales::in-box::table_email": "Outgoing mail",
  "after-sales::in-box::table_email_count": "Number of messages",
  "after-sales::in-box::table_email_sort": "Mail Classification",
  "after-sales::in-box::table_email_tag": "Mailing Labels",
  "after-sales::in-box::table_email_topic": "Email Subject",
  "after-sales::in-box::table_handler": "principal",
  "after-sales::in-box::table_number": "Numbering",
  "after-sales::in-box::table_operate": "operating",
  "after-sales::in-box::table_remark": "Remark",
  "after-sales::in-box::table_reply": "Reply",
  "after-sales::in-box::table_shop": "Shop",
  "after-sales::in-box::write": "write a letter",
  "after-sales::in-box::write_letter": "write a letter",
  "amount_is_too_large": "The refund amount may not exceed the amount of the refund",
  "AUDIT_STATUS_ERROR": "Audit abnormal state",
  "AUTHORIZE_SELF_ERROR": "Licenses to own",
  "AUTHORIZE_USER_EXIT": "Authorized user already exists",
  "AUTHORIZE_USER_NOT_EXIT": "Authorized user does not exist",
  "bind_phone_error": "Binding fails, please pay attention to the public No.",
  "bind_phone_error_code": "Binding fails, please re-scan code",
  "board::adcost_title": "Advertising spending",
  "board::adcost_tooltip": "The total cost of Google and facebook advertising",
  "board::adfee_title": "Advertising costs TOP5",
  "board::adfee::table_adCost": "Advertising spending",
  "board::adfee::table_adCostRate": "Advertising spending accounted for",
  "board::adfee::table_shop": "Shop",
  "board::adfunnel_title": "Creative Conversion Funnel",
  "board::adfunnel::funnel_addBuy": "Plus the amount purchased",
  "board::adfunnel::funnel_click": "Traffic",
  "board::adfunnel::funnel_count": "Launch checkout amount",
  "board::adfunnel::funnel_order": "The order volume",
  "board::adfunnel::funnel_show": "Display amount",
  "board::adfunnel::funnel_visitor": "Landing page views",
  "board::adROI_tooltip": "The formula: the amount of advertising sales / advertising costs, statistical types of ads: Google and facebook",
  "board::adsales_title": "Advertising ROI TOP5 shop",
  "board::adsales::table_sales": "Advertising sales",
  "board::adsales::table_shop": "Shop",
  "board::auth_tooltip": "You can set up your account overview presentation [marketing]",
  "board::channel_title": "Channel decomposition",
  "board::date": "date",
  "board::feechannel_title": "Pay channels",
  "board::naturechannel_title": "Natural channels",
  "board::notPaySales_title": "Non-paid sales",
  "board::notPaySales_tooltip": "The formula is: Sales - Paid Sales - Sales natural",
  "board::paySales_title": "Pay Sales",
  "board::paySales_tooltip": "Sales from paid channels, including Google ads, Facebook ads and KOLs,<br /> Field: utm_term=facebook or google",
  "board::sales_title": "Sales",
  "board::sales_tooltip": "The total amount paid orders actually paid the corresponding",
  "board::shopName": "Store Name",
  "board::trend_title": "trend analysis",
  "board::trend::line_addBuy": "Plus the amount purchased",
  "board::trend::line_addBuyRate": "Plus purchase rate",
  "board::trend::line_click": "Traffic",
  "board::trend::line_clickRate": "Click to rate",
  "board::trend::line_order": "The order volume",
  "board::trend::line_payment": "Launch checkout amount",
  "board::trend::line_paymentRate": "Initiate settlement rate",
  "board::trend::line_show": "Display amount",
  "board::trend::line_transRate": "Ad conversion rate",
  "board::trend::line_visitorRate": "Reservation",
  "board::unfeechannel_title": "Non-payment channels",
  "cell_phone_error": "Mobile terminal currently prohibit apply for trial",
  "CS_ACCOUNT_NOT_FOUND": "客服邮箱(id:%s)不存在",
  "CS_ACCOUNT_SHOP_IS_EXIT": "Shop is already bound to change other mailbox",
  "CS_ACCOUNT_SHOP_NOT_EXIT": "The shop is not bound to any mailbox",
  "CS_BINDING_IS_EXIT": "The binding already exists, bind failure",
  "CS_BINDING_ORDER_IS_NOT_EXIT": "According orderId not find the corresponding mailbox",
  "CS_Contacts_NOT_FOUND": "The message does not exist",
  "CS_INBOX_HAS_NOT_EMAIL": "The sender does not correspond to Inbox",
  "CS_INBOX_NOT_FOUND": "收件箱(id:%s)不存在",
  "CS_MERCHANT_IS_NOT": "Not part of the business",
  "CS_ORDER_HAS_NOT_EMAIL": "The order does not correspond to the mailbox",
  "CS_SENDMAIL_AUTHENTICATION_FAIL": "Failure sending mail, authentication fails, check your outgoing mail server address or account password",
  "CUSTOM_FAIL": "system error",
  "CUSTOMER_EXIT": "Customers already exists",
  "customer_is_not_exit_or_not_this_merchant": "The customer does not exist or is not the business",
  "customer_is_not_this_merchant": "The customer is not the business",
  "CUSTOMER_SERVICE_EMAIL_ID_NO_FIND": "The id not find the corresponding customer service email",
  "CUSTOMER_SERVICE_EMAIL_IS_NOT_MERCHANT": "The mailbox is not the business",
  "CUSTOMER_SERVICE_EMAIL_MERCHANT_ID_ISNULL": "Merchant id is empty",
  "customer_tag_is_not_exit": "The binding relationship does not exist",
  "customer::customer-list::add_customer": "New Customers",
  "customer::customer-list::add_success": "added successfully",
  "customer::customer-list::add_tag": "add tag",
  "customer::customer-list::address": "address",
  "customer::customer-list::after_sale_refund": "Sale and refund",
  "customer::customer-list::after_sales_order": "Number of sale orders",
  "customer::customer-list::at_least_one": "Please check at least one customer",
  "customer::customer-list::base_info": "Basic Information",
  "customer::customer-list::basic_info": "basic information",
  "customer::customer-list::batch_tag": "Batch marking",
  "customer::customer-list::belong_platform": "Owned platform",
  "customer::customer-list::belong_shop": "Their stores",
  "customer::customer-list::buy_count": "Purchases",
  "customer::customer-list::buy_history": "Shopping History",
  "customer::customer-list::cancel": "cancel",
  "customer::customer-list::cancel_subscribe_success": "Unsubscribe successful",
  "customer::customer-list::commonly_used": "Common",
  "customer::customer-list::confirm": "determine",
  "customer::customer-list::consume": "Amount of consumption",
  "customer::customer-list::create_begin_time": "Creating Start Time",
  "customer::customer-list::create_end_time": "Creating End Time",
  "customer::customer-list::create_time": "Created",
  "customer::customer-list::customer_level": "Customers rating",
  "customer::customer-list::customer_level_select": "Please select customer rating",
  "customer::customer-list::customer_name": "customer name",
  "customer::customer-list::customer_no_consume": "The customer is not a single consumer in any shop",
  "customer::customer-list::customer_tag": "Customers label",
  "customer::customer-list::deal_amount": "Turnover",
  "customer::customer-list::deal_amount_max": "The maximum amount of transactions",
  "customer::customer-list::deal_amount_min": "The minimum amount of turnover",
  "customer::customer-list::delete_tag_success": "Remove label success",
  "customer::customer-list::deliver_wait": "to be delivered",
  "customer::customer-list::delivered": "Shipped",
  "customer::customer-list::detail": "Detail",
  "customer::customer-list::detail_info": "details",
  "customer::customer-list::edit": "edit",
  "customer::customer-list::edit_customer": "Edit Customers",
  "customer::customer-list::edit_success": "Edited successfully",
  "customer::customer-list::edit_tag_success": "Edit label success",
  "customer::customer-list::email": "mailbox",
  "customer::customer-list::email_input": "please input your email",
  "customer::customer-list::email_input_correct": "Please enter a valid email",
  "customer::customer-list::end_time": "End Time",
  "customer::customer-list::first_name": "name",
  "customer::customer-list::first_name_input": "Please enter a last name",
  "customer::customer-list::first_order_time": "First time orders",
  "customer::customer-list::fullfillment_status": "Logistics state",
  "customer::customer-list::grand_total": "Total consumption",
  "customer::customer-list::has_subscribe": "Subscribed",
  "customer::customer-list::join_time": "Joined",
  "customer::customer-list::last_name": "name",
  "customer::customer-list::last_name_input": "Please enter name",
  "customer::customer-list::list": "Customer List",
  "customer::customer-list::max_consume": "The maximum amount",
  "customer::customer-list::min_consume": "The minimum amount of consumption",
  "customer::customer-list::no_deliver_addr": "No shipping address",
  "customer::customer-list::no_subscribe": "Not subscribed",
  "customer::customer-list::often": "often",
  "customer::customer-list::one_time": "1 time",
  "customer::customer-list::one_time_more": "1 and above",
  "customer::customer-list::opt": "operating",
  "customer::customer-list::order_quantity": "Singular case",
  "customer::customer-list::order_quantity_max": "The maximum number of orders",
  "customer::customer-list::order_quantity_min": "Minimum order number",
  "customer::customer-list::order_status": "Order Status",
  "customer::customer-list::order_total": "Total order",
  "customer::customer-list::pay_end_time": "End time payment",
  "customer::customer-list::pay_start_time": "Start time payment",
  "customer::customer-list::pay_status": "Payment status",
  "customer::customer-list::pay_time": "Payment time",
  "customer::customer-list::pay_type": "payment method",
  "customer::customer-list::phone": "phone number",
  "customer::customer-list::phone_number": "cellphone number",
  "customer::customer-list::prod_num": "amount of goods",
  "customer::customer-list::recipient": "Addressee",
  "customer::customer-list::registered_status": "Registration Overview",
  "customer::customer-list::select_tag": "Please select tag",
  "customer::customer-list::select_tag_btn": "Select the tab",
  "customer::customer-list::select_tag_one": "Please select at least one tag",
  "customer::customer-list::select_tag_success": "Batch marking success",
  "customer::customer-list::set_commonly_used_addr": "To address common",
  "customer::customer-list::setting_success": "Setting Success",
  "customer::customer-list::shipping_address": "Shipping address",
  "customer::customer-list::shop_name": "Store Name",
  "customer::customer-list::shop_order_num": "Shop Order Number",
  "customer::customer-list::subscribe_success": "Subscribe successful",
  "customer::customer-list::subscribe_time": "Subscribe state",
  "customer::customer-list::tag": "label",
  "customer::customer-list::tag_batch_add": "Batch tagging",
  "customer::customer-list::ten_limit": "Optional 10",
  "customer::customer-list::ten_limit_max": "Choose up to 10",
  "customer::customer-list::times": "Secondary",
  "customer::customer-list::total_spending": "Total spending (USD)",
  "customer::customer-list::two_time_more": "2 times or more",
  "customer::customer-list::use": "use",
  "customer::customer-list::zero_time": "0 times",
  "customer::customer-manager::cancel": "cancel",
  "customer::customer-manager::confirm": "determine",
  "customer::customer-manager::delete": "delete",
  "customer::customer-manager::delete_confirm": "Customers confirm the deletion of the rank?",
  "customer::customer-manager::edit": "edit",
  "customer::customer-manager::edit_level": "Edit customer rating",
  "customer::customer-manager::level": "Customers rating",
  "customer::customer-manager::level_add": "New customer rating",
  "customer::customer-manager::level_delete_not": "Customers rating can not be empty",
  "customer::customer-manager::opt": "operating",
  "customer::customer-manager::setting": "Customers Set",
  "customer::customer-manager::sort_code": "No.",
  "customer::customer-manager::tag": "Customers label",
  "customer::customer-manager::tag_add": "New customer label",
  "customer::customer-manager::tag_delete_not": "Customers label can not be empty",
  "customer::customer-manager::tag_delete_tips": "Customers confirm the removal of the label?",
  "customer::customer-manager::tag_edit": "Edit customer label",
  "customer::customer-manager::tips": "prompt",
  "customer::customers-notice::activity_info": "Event Information",
  "customer::customers-notice::activity_name": "Event name",
  "customer::customers-notice::add": "New activities",
  "customer::customers-notice::after_click_info": "After clicking ‘Send’ to send delayed entry into force, the draft does not send the deposit;",
  "customer::customers-notice::all": "all",
  "customer::customers-notice::all_user": "All subscribers",
  "customer::customers-notice::arrange_send": "It has arranged to send",
  "customer::customers-notice::avtivity_name": "Event name",
  "customer::customers-notice::cancel": "cancel",
  "customer::customers-notice::check": "View",
  "customer::customers-notice::confirm": "determine",
  "customer::customers-notice::content": "content",
  "customer::customers-notice::count": "Order number",
  "customer::customers-notice::de": "of",
  "customer::customers-notice::delay_send": "Delayed Transmission",
  "customer::customers-notice::delete": "delete",
  "customer::customers-notice::delete_confirm": "Confirm delete this e-mail marketing it?",
  "customer::customers-notice::delete_tips": "Once deleted can not be recovered, exercise caution",
  "customer::customers-notice::draft": "draft",
  "customer::customers-notice::edit": "edit",
  "customer::customers-notice::email": "Outgoing mail",
  "customer::customers-notice::email_obj": "Mail objects",
  "customer::customers-notice::email_send_to": "E-mail will be sent to",
  "customer::customers-notice::email_setting": "a",
  "customer::customers-notice::emial_content": "content of email",
  "customer::customers-notice::in_draft": "Save draft",
  "customer::customers-notice::level": "Customers rating",
  "customer::customers-notice::one_time": "1 time",
  "customer::customers-notice::opt": "operating",
  "customer::customers-notice::over_one_time": "1 and above",
  "customer::customers-notice::over_time": "Obsolete, please re-select transmission time",
  "customer::customers-notice::placeholder_content": "Please enter a message",
  "customer::customers-notice::placeholder_date": "Select dates",
  "customer::customers-notice::placeholder_email": "Please select the sender mailbox",
  "customer::customers-notice::placeholder_name": "Please enter the event name",
  "customer::customers-notice::placeholder_time": "Select time",
  "customer::customers-notice::please_select": "please choose",
  "customer::customers-notice::recipient": "Addressee",
  "customer::customers-notice::second_time": "2 times or more",
  "customer::customers-notice::select_date": "Select time",
  "customer::customers-notice::select_long_date": "Select Date",
  "customer::customers-notice::select_time": "selection period",
  "customer::customers-notice::sell_strategy": "Marketing strategy",
  "customer::customers-notice::send": "send",
  "customer::customers-notice::send_email": "send email",
  "customer::customers-notice::send_success": "Sent successfully",
  "customer::customers-notice::send_time": "Send Time",
  "customer::customers-notice::sending": "sending",
  "customer::customers-notice::sending_now": "sending",
  "customer::customers-notice::setting_right": "Your customer service mailbox is empty, click on the right setting",
  "customer::customers-notice::setting_tips": "The customer intelligence to maintain cost-effective reach of every customer contact, customer secondary promote consumption, improve store sales",
  "customer::customers-notice::single": "Place",
  "customer::customers-notice::status": "status",
  "customer::customers-notice::tag": "Customers label",
  "customer::customers-notice::tips": "prompt",
  "customer::customers-notice::total": "Altogether",
  "customer::customers-notice::update_time": "Updated",
  "customer::customers-notice::user": "subscriber",
  "customer::customers-notice::wait_send": "To be sent",
  "customer::customers-notice::warning_message": "You have not set a mailbox",
  "customer::customers-notice::x_count": "Total X-bit",
  "customer::customers-notice::zero_time": "0 times",
  "dashboard-bi::admin-config::add_module": "Adding model",
  "dashboard-bi::admin-config::copy": "copy",
  "dashboard-bi::admin-config::delete": "delete",
  "dashboard-bi::admin-config::edit": "edit",
  "dashboard-bi::admin-config::select_module": "Select Database Engine",
  "dashboard-bi::admin-config::tab_module": "Model configuration",
  "dashboard-bi::admin-config::tip_delete": "Delete of the record?",
  "dashboard-bi::default-board::cancel": "cancel",
  "dashboard-bi::default-board::confrim": "determine",
  "dashboard-bi::default-board::copy_default": "Copy the default Kanban",
  "dashboard-bi::default-board::no_screen": "Exit Full Screen",
  "dashboard-bi::default-board::screen": "Full Screen",
  "dashboard-bi::default-board::select": "Please select Kanban",
  "dashboard-bi::default-board::loading": "Loading...",
  "dashboard-bi::edit-report::advance_tip": "The first push forward",
  "dashboard-bi::edit-report::black_option": "black",
  "dashboard-bi::edit-report::chart_all": "Summary chart",
  "dashboard-bi::edit-report::chart_area": "Area chart",
  "dashboard-bi::edit-report::chart_bar": "Bar chart",
  "dashboard-bi::edit-report::chart_design": "Graphic Design",
  "dashboard-bi::edit-report::chart_line": "Line chart",
  "dashboard-bi::edit-report::chart_pie": "Pie chart",
  "dashboard-bi::edit-report::chart_pile": "Stacked charts",
  "dashboard-bi::edit-report::chart_type": "Chart Type",
  "dashboard-bi::edit-report::click_or_drop_number": "Dragging or double click here numeric field",
  "dashboard-bi::edit-report::data_filter": "Data filtering",
  "dashboard-bi::edit-report::data_filter_holder": "please choose",
  "dashboard-bi::edit-report::default": "default",
  "dashboard-bi::edit-report::dialog::batch_choice_cancel_select": "cancel selection",
  "dashboard-bi::edit-report::dialog::batch_choice_data_module": "Data Model",
  "dashboard-bi::edit-report::dialog::batch_choice_data_module_hodler": "Please select model",
  "dashboard-bi::edit-report::dialog::batch_choice_number_list": "A list of values:",
  "dashboard-bi::edit-report::dialog::batch_choice_search_keyword_holder": "search keyword",
  "dashboard-bi::edit-report::dialog::batch_choice_select_all": "Select All",
  "dashboard-bi::edit-report::dialog::batch_choice_select_btn": "Batch Selection",
  "dashboard-bi::edit-report::dialog::batch_choice_title": "Batch Selection",
  "dashboard-bi::edit-report::dialog::btn::delete_tip": "Delete tips",
  "dashboard-bi::edit-report::dialog::custom_number": "Custom Digital",
  "dashboard-bi::edit-report::dialog::decimal_info": "Decimal places",
  "dashboard-bi::edit-report::dialog::delete_higher_string": "Delete advanced fields",
  "dashboard-bi::edit-report::dialog::dimension": "Dimensions",
  "dashboard-bi::edit-report::dialog::dimension_list": "List of dimensions:",
  "dashboard-bi::edit-report::dialog::higher_title": "Advanced Configuration Fields",
  "dashboard-bi::edit-report::dialog::number": "Numerical",
  "dashboard-bi::edit-report::dialog::number_info": "Value Unit",
  "dashboard-bi::edit-report::dialog::select_board_title": "Please select Kanban",
  "dashboard-bi::edit-report::dialog::select_holder": "Please select Kanban",
  "dashboard-bi::edit-report::dialog::selected_dimension": "Selected dimensions:",
  "dashboard-bi::edit-report::dialog::selected_number": "Selected values:",
  "dashboard-bi::edit-report::dialog::set_condition_style_title": "Conditional Formatting",
  "dashboard-bi::edit-report::dialog::set_higher_string": "Configure advanced fields",
  "dashboard-bi::edit-report::dialog::set_number_style_title": "Numerical Display Format Set",
  "dashboard-bi::edit-report::dialog::show_number": "Numerical display",
  "dashboard-bi::edit-report::dialog::show_percentage": "It is displayed as a percentage",
  "dashboard-bi::edit-report::dialog::string_name": "Please enter a name for the field:",
  "dashboard-bi::edit-report::dialog::string_name_holder": "Please enter the Advanced Field Name",
  "dashboard-bi::edit-report::dialog::tip_input_holder": "Set tips",
  "dashboard-bi::edit-report::dialog::tip_title": "Setting tips",
  "dashboard-bi::edit-report::dimension": "Dimensions",
  "dashboard-bi::edit-report::double_shaft": "Biaxial",
  "dashboard-bi::edit-report::down_option": "Down Arrow",
  "dashboard-bi::edit-report::edit_custom_report": "Edit Custom Report",
  "dashboard-bi::edit-report::export_excel": "Export excel",
  "dashboard-bi::edit-report::filter": "Data filtering",
  "dashboard-bi::edit-report::freeze_column": "Freeze columns table configuration (excluding ‘No.’ column)",
  "dashboard-bi::edit-report::green_option": "green",
  "dashboard-bi::edit-report::in_tag": "Label displayed inside",
  "dashboard-bi::edit-report::input_content_holder": "Please enter content",
  "dashboard-bi::edit-report::line_option": "Horizontal line",
  "dashboard-bi::edit-report::new_custom_report": "New Custom Report",
  "dashboard-bi::edit-report::no_data_filter": "No filter criteria:",
  "dashboard-bi::edit-report::no_option": "no",
  "dashboard-bi::edit-report::no_pile": "Do not stack",
  "dashboard-bi::edit-report::number": "Numerical",
  "dashboard-bi::edit-report::out_tag": "Label displayed on the outside",
  "dashboard-bi::edit-report::pageSize": "Per number of configuration",
  "dashboard-bi::edit-report::pick_up": "Collapse",
  "dashboard-bi::edit-report::pile": "Stacking",
  "dashboard-bi::edit-report::please_condition_tip": "This dimension is mandatory",
  "dashboard-bi::edit-report::please_data_filter_tip": "Please click on the top drop-down box to select the type of screening",
  "dashboard-bi::edit-report::please_number_tip": "Please enter the full digital",
  "dashboard-bi::edit-report::red_option": "red",
  "dashboard-bi::edit-report::report_info": "Report Information",
  "dashboard-bi::edit-report::report_info_holder": "Please enter report information",
  "dashboard-bi::edit-report::report_info_name": "Please enter the name of the report",
  "dashboard-bi::edit-report::section": "Interval",
  "dashboard-bi::edit-report::select_chart": "Select the chart",
  "dashboard-bi::edit-report::select_string": "Selected fields:",
  "dashboard-bi::edit-report::shaft": "Uniaxial",
  "dashboard-bi::edit-report::tip": "提示",
  "dashboard-bi::edit-report::tip_day": "day",
  "dashboard-bi::edit-report::tip_info": "是否删除该报表？",
  "dashboard-bi::edit-report::top_option": "Arrow",
  "dashboard-bi::edit-report::unfold": "Expansion",
  "dashboard-bi::person-board::add": "添加看版",
  "dashboard-bi::person-board::board_name": "Kanban name",
  "dashboard-bi::person-board::board_name_holder": "Please choose to see the version",
  "dashboard-bi::person-board::create": "新建自定义报表",
  "dashboard-bi::person-board::delete": "Delete Look version",
  "dashboard-bi::person-board::delete_tip": "确定删除看板吗？",
  "dashboard-bi::person-board::dimension_holder": "请选择联动的维度",
  "dashboard-bi::person-board::edit": "编辑看版",
  "dashboard-bi::person-board::edit_board": "编辑看板名称",
  "dashboard-bi::person-board::input_board_name": "请输入看板名称",
  "dashboard-bi::person-board::new_board": "新增看板",
  "dashboard-bi::person-board::no_screen": "Exit Full Screen",
  "dashboard-bi::person-board::option_condition_gear": "Conditions linkage",
  "dashboard-bi::person-board::option_result_gear": "Linkage results",
  "dashboard-bi::person-board::screen": "Full Screen",
  "dashboard-bi::person-board::select_all": "select all",
  "dashboard-bi::person-board::select_dimension": "选择联动的维度：",
  "dashboard-bi::person-board::select_holder": "请选择看板",
  "dashboard-bi::person-board::select_table": "Choose linkage table:",
  "dashboard-bi::person-board::select_type": "Select action types:",
  "dashboard-bi::person-board::table_holder": "Please select Linkage Table",
  "dashboard-bi::person-board::title": "Linkage Table Selection",
  "dashboard-bi::person-board::type_holder": "Please select the type of linkage",
  "dashboard-bi::person-board:screen": "全屏浏览",
  "DATA_DUPLICATE_ERROR": "Data already exists",
  "DATA_ERROR": "Data anomalies",
  "DATA_EXIST": "Data already exists!",
  "DATA_NOT_EXIST": "Data does not exist!",
  "direction_param_error": "direction field is not legitimate",
  "EMAIL_ALREADY_EXIST": "The current mailbox is already registered, please replace the mailbox",
  "email_data_is_null": "No friends to send objects, please re-select the recipient",
  "EMAIL_TYPE_IS_EXIT": "The same type of e-mail, rename!",
  "ENTERPRISE_WECHAT_ERROR": "微信接口调用异常:%s",
  "etl_data_error": "etl数据异常:%s",
  "ETL_QUERY_CHECK_ERROR": "Illegal etl request",
  "etl_query_error": "Illegal etl request",
  "EXPIRE_TIME_FAIL": "Expiration date can not be earlier than the Registration Time",
  "facebook_account_name_is_exist": "The same account name",
  "failed_save_data": "Save EDM marketing data failed",
  "failed_update_data": "EDM marketing data update failed",
  "FILE_UPLOAD_CONFIG_ERROR": "File upload, configuration errors.",
  "FLOW_CONTROL_EXCEPTION": "System congestion ahead, please try again later",
  "GET_SHOP_ERROR": "店铺获取异常：%s",
  "GET_SHOP_RATE": "Currency Gets the exception",
  "GET_SKU_COUNT_ERROR": "店铺订单可用库存异常：%s",
  "GET_USER_DATA_ERROR": "Obtain user data anomalies shop",
  "GIVE_USER_TOKEN_INVALID": "token failure",
  "I18N_CACHE_QUERY_NON_PARAMS": "Glossary cache query parameter is empty",
  "inoutstock_export_data_is_empty": "Exporting data is empty",
  "inoutstock_export_data_is_too_big": "Export data overload",
  "INOUTSTOCK_EXPORT_FAILED": "Export Failed",
  "inoutstock_impost_file_price_less_than_0": "Importing files exist commodity is less than the amount of 0",
  "inoutstock_impost_file_quantity_less_than_0": "Goods smaller than the number of present import file 0",
  "inoutstock_impost_file_to_big": "Import file is larger than 5000, the import fails",
  "inoutstock_impost_is_failed": "Failed to import sku",
  "inoutstock_impost_sku_has_repeat": "Sku introduced duplicate, import fails",
  "inoutstock_impost_sku_is_not_this_supplier": "导入sku%s不属于选定供应商的，导入失败",
  "inoutstock_is_not_found": "Can not find a single storage",
  "inoutstock_is_not_this_merchant": "Not a single change to change out of storage business",
  "inoutstock_statu_is_not_pending_review": "Not a single state out of storage pending review",
  "input_logistics_id_error": "Please enter the correct information logistics providers",
  "INSERT_VOCABULARY_ERROR": "New vocabulary synchronization businesses fail",
  "instock_stocktype_is_exit": "The same storage type, rename!",
  "IP_LIMIT": "Sorry, you log the number of errors mostly, has restricted access, please try again later!",
  "LANGUAGE_EXIST": "已存在%s(%s)语言翻译数据，新增失败！",
  "list_too_long": "The number of imported goods can not be more than 1000",
  "login::accept": "I accept",
  "login::account::text": "By your account password, or",
  "login::agreement::secret": "’PrivacyAgreement‘",
  "login::agreement::usage": "’UseAgreement‘",
  "login::agreement::user": "‘UserAgreement’",
  "login::btn::confirm": "confirm",
  "login::code::send::fail": "Send SMS verification code failed",
  "login::code::send::success": "Verification code sent successfully",
  "login::customer::service": "Advisory Service",
  "login::customer::service::ask": "Contact customer service Q & A",
  "login::customer::service::hide": "Hide Customer Service",
  "login::customer::service::scan": "scan it",
  "login::desc::first": "0 Threshold station moved Station",
  "login::desc::fourth": "Many-professional guidance service",
  "login::desc::second": "International store templates",
  "login::desc::third": "Supports multiple payment channels",
  "login::desc::title": "You can experience by Shoplus",
  "login::dialog::content": "In order to better demonstrate the positioning of the ’integratedsolutionforbrandgoingoverseas‘, and enhance the recognition and influence in the field of cross-border e-commerce services. We have decided to change the Chinese and English name of ’AlgobuySuperStore‘ to ’SuperStoreShoplus‘ from now on, and use the latest brand image logo. The specific updates are as follows:",
  "login::dialog::OK": "Ok",
  "login::dialog::text": "Thank you for your continued attention and support, and hope that you like our new brand ‘Shoplus’ as much as we do. Zhizhen Technology will continue to provide you with high-quality full-case services and digital products to bring you more A new experience of high-value brands going overseas.",
  "login::dialog::thanks": "Thanks for your continued interest and support of Algobuy!",
  "login::dialog::title": "Dear friends:",
  "login::edit::password": "change Password",
  "login::email::tips": "The phone number used only for registration verification, can not be used to log!",
  "login::forget::password": "Forgot password",
  "login::help::center": "Help",
  "login::holder::confirm::password": "Please enter the confirmation code",
  "login::message::edit::password": "successfully change password",
  "login::message::exam::fail": "Audit failure",
  "login::message::exam::warning": "under review",
  "login::message::register::success": "registration failed",
  "login::message::sign::fail": "Login failed",
  "login::message::sign::success": "login successful",
  "login::message::system::error": "System desertion",
  "login::message::time::error": "Account has expired",
  "login::phone::google_sign": "We recommend the use of Google Chrome",
  "login::phone::open": "Start your journey at sea",
  "login::phone::PC_sign": "Please use the PC",
  "login::phone::text": "Verification code through your mobile phone, or",
  "login::phone::user": "Congratulations, you are already a registered user",
  "login::register": "registered",
  "login::register::email": "email registration",
  "login::register::free": "free registration",
  "login::register::phone": "Mobile phone number registered",
  "login::return": "Back Log",
  "login::rule::agreement": "Check Use Agreement",
  "login::rule::code": "Please enter the verification code SMS",
  "login::rule::email": "please input your email",
  "login::rule::password": "Please enter a password (8-16 digits required letter combination +)",
  "login::rule::password_equal": "Password inconsistent",
  "login::rule::phone": "Please enter your mobile number (only supported in mainland China mobile phone number +86)",
  "login::rule::phone_email": "Please enter the email / phone number",
  "login::rule::right_email": "Please enter a valid e-mail format (50 characters or less)",
  "login::rule::right_password": "For account security, the password must be a combination of 8-16 letters + digits",
  "login::rule::right_phone": "The phone number is not formatted correctly",
  "login::rule::system": "Check the system that you want to register",
  "login::send_code": "Send the verification code",
  "login::sign::seven_day": "7 days of free Log in",
  "login::submit::account": "account password",
  "login::submit::phone": "Phone code",
  "login::title": "log in",
  "logistics_is_exist": "This stream is already present in this business",
  "menu::after-sales": "Aftermarket management",
  "menu::after-sales::after-sale-list": "Sale orders",
  "menu::after-sales::after-sales-set": "Set sale",
  "menu::after-sales::email-setting": "E-Mail settings",
  "menu::after-sales::in-box": "inbox",
  "menu::customer": "Customer Management",
  "menu::customer::customer-list": "Customer List",
  "menu::customer::customer-manager": "Customers Set",
  "menu::customer::customers-notice": "Customers notice",
  "menu::dashboard-bi": "Custom Report",
  "menu::dashboard-bi::admin-config": "Backstage management",
  "menu::dashboard-bi::default-board": "The default data Kanban",
  "menu::dashboard-bi::edit-report": "Edit Report",
  "menu::dashboard-bi::person-board": "Personal Folders",
  "menu::data-analysis": "Marketing Analysis",
  "menu::data-analysis::ad-analysis": "Advertising Analytics",
  "menu::data-analysis::board": "Marketing Overview",
  "menu::operation": "Operations Analysis",
  "menu::operation::month-profits": "Profit Monthly",
  "menu::operation::performance-board": "Behavior analysis",
  "menu::operation::sale-analysis": "sales analysis",
  "menu::performance": "Performance Analysis",
  "menu::performance::performance-analysis": "Performance Overview",
  "menu::purchase": "Purchasing Management",
  "menu::purchase::purchase-list": "purchase order",
  "menu::sales-analysis": "Aftermarket Analysis",
  "menu::sales-analysis::sale-order": "Refund Overview",
  "menu::sales-analysis::work-order": "Ticket Overview",
  "menu::storage": "Inventory Management",
  "menu::storage::commodity-stocks": "Commodity stocks",
  "menu::storage::in-stock": "Receipts",
  "menu::storage::out-stock": "Deliveries",
  "menu::stores": "Store Management",
  "menu::stores::order": "Order List",
  "menu::stores::product-manager": "Product settings",
  "menu::stores::products-info": "Product List",
  "menu::stores::shop-site": "Set up shop",
  "menu::stores::store": "Store List",
  "menu::stores::supplier": "Vendor List",
  "menu::system": "System Settings",
  "menu::system::exchange-manager": "Exchange rate set",
  "menu::system::rbac-manager": "Authorization Management",
  "menu::user-guidance": "Background Home",
  "MESSAGE_SEND_CLIENT_ERROR": "Abnormal Ali cloud messaging client",
  "MESSAGE_SEND_ERROR": "验证码发送错误,错误码:%s",
  "MESSAGE_SEND_SERVER_ERROR": "Ali cloud messaging service exception",
  "message-center::notice_button": "Mark All Read",
  "message-center::tab_message": "system information",
  "message-center::tab_notice": "Official Announcement",
  "month-profits::date": "date",
  "month-profits::site-pofits::name": "Site name",
  "month-profits::site-pofits::tab_title": "Site monthly profit",
  "month-profits::site-pofits::table_adcost": "Advertising costs",
  "month-profits::site-pofits::table_grossMargin": "Gross margin",
  "month-profits::site-pofits::table_grossProfit": "Gross profit",
  "month-profits::site-pofits::table_logisticsCost": "Logistics costs",
  "month-profits::site-pofits::table_proCost": "Cost of goods",
  "month-profits::site-pofits::table_refundAmount": "Refund Amount",
  "month-profits::site-pofits::table_salesMoney": "Total sales",
  "month-profits::site-pofits::table_salesNum": "Sales",
  "month-profits::site-pofits::table_shopName": "Site name",
  "month-profits::site-pofits::tip_pay": "Total expenditure costs",
  "month-profits::site-pofits::tip_profit": "Total profit",
  "month-profits::site-pofits::tip_sales": "Merchandise sales",
  "month-profits::staff-pofits::name": "Optimizers name",
  "month-profits::staff-pofits::tab_title": "Operating profit Monthly staff",
  "month-profits::staff-pofits::table_grossMargin": "Gross margin performance",
  "month-profits::staff-pofits::table_grossProfit": "Gross profit performance",
  "month-profits::staff-pofits::table_name": "Optimizers name",
  "month-profits::staff-pofits::table_roi": "Advertising ROI",
  "month-profits::staff-pofits::tip_pay": "Total expenditure costs",
  "month-profits::staff-pofits::tip_profit": "Total gross profit performance",
  "month-profits::staff-pofits::tip_sales": "Optimization of total sales division",
  "NO_AUTHORIZE_USER": "Unauthorized users",
  "no_data_error": "Account is empty",
  "no_data_found": "The corresponding data is not found",
  "NO_SYSTEM_AUTH": "You have registered to open a trial account, please contact customer service to open a merchant account.",
  "NOT_PROVIDE_FILE": "不支持的文件类型: %s",
  "NOTIFICATION_SEND_ERROR": "Push abnormal log messages",
  "NULL_TOKEN_ERROR": "token can not be empty",
  "ocean-bi:0-5天发货率": "0-5 days delivery rate",
  "ocean-bi:0-5天发货订单数": "0-5 days delivery order number",
  "ocean-bi:10-15天发货率": "10-15 days delivery rate",
  "ocean-bi:10-15天发货订单数": "10-15 days delivery order number",
  "ocean-bi:12-24小时回复数": "12-24 hours Replies",
  "ocean-bi:12小时内回复数": "Replies within 12 hours",
  "ocean-bi:15天以上发货率": "More than 15 days delivery rate",
  "ocean-bi:15天以上发货订单数": "The number of orders shipped more than 15 days",
  "ocean-bi:24-48小时回复数": "24-48 hours Replies",
  "ocean-bi:上网子订单数": "Internet child order number",
  "ocean-bi:上网率": "Internet rate",
  "ocean-bi:主动退款金额": "Initiative refund amount",
  "ocean-bi:主动退款金额占比": "Refund Amount Percentage initiative",
  "ocean-bi:付费销售额": "Pay Sales",
  "ocean-bi:付费销售额占比": "Pay sales accounting",
  "ocean-bi:加购率": "Plus purchase rate",
  "ocean-bi:发件人名称": "Sender Name",
  "ocean-bi:发货-妥投20天子订单数": "Delivery - 20 Tuotou emperor orders",
  "ocean-bi:发货-妥投20天子订单数占比": "Delivery --20 emperor number of orders accounted Tuotou",
  "ocean-bi:发货-妥投30天子订单数": "Delivery --30 emperor number of orders Tuotou",
  "ocean-bi:发货-妥投30天子订单数占比": "Delivery --30 emperor number of orders accounted Tuotou",
  "ocean-bi:发货率": "Delivery rate",
  "ocean-bi:发起结账量": "Launch checkout amount",
  "ocean-bi:售后单创建日期": "After sales order creation date",
  "ocean-bi:售后单创建月份": "Create a single sale in January",
  "ocean-bi:售后单号": "No single sale",
  "ocean-bi:售后单数": "Aftermarket singular",
  "ocean-bi:售后商品数量": "Sale quantity",
  "ocean-bi:售后总金额": "The total sale amount",
  "ocean-bi:售后状态": "Aftermarket state",
  "ocean-bi:商品名称": "product name",
  "ocean-bi:商品图片": "product picture",
  "ocean-bi:商品销售数量": "商品销售数量",
  "ocean-bi:商户id": "商户id",
  "ocean-bi:回复人名称": "Name of reply",
  "ocean-bi:回复数": "Replies",
  "ocean-bi:回复日期": "Reply Date",
  "ocean-bi:国家": "country",
  "ocean-bi:妥投率": "Tuotou rate",
  "ocean-bi:妥投订单数": "Tuotou number of orders",
  "ocean-bi:妥投金额": "Tuotou amount",
  "ocean-bi:子订单号": "Child order number",
  "ocean-bi:实际支付运费": "The actual payment of freight",
  "ocean-bi:客单价": "Customer price",
  "ocean-bi:客诉用户数": "Customer complaints users",
  "ocean-bi:已发货子订单数": "Shipped sub-orders",
  "ocean-bi:已发货订单数": "Shipped orders",
  "ocean-bi:已支付子订单数": "Paid sub-orders",
  "ocean-bi:已支付订单数": "Paid orders",
  "ocean-bi:广告下单量": "The order volume of advertising",
  "ocean-bi:广告加购率": "Advertising rate plus purchase",
  "ocean-bi:广告发起结算率": "Advertising initiate settlement rate",
  "ocean-bi:广告名称": "Ad Name",
  "ocean-bi:广告展示量": "Ad volume",
  "ocean-bi:广告投放日期": "Advertising date",
  "ocean-bi:广告投放月份": "Ad month",
  "ocean-bi:广告支付转化率": "Ads pay conversion rate",
  "ocean-bi:广告浏览率": "Ad view rate",
  "ocean-bi:广告点击率": "CTR",
  "ocean-bi:广告点击量": "Ad Traffic",
  "ocean-bi:广告系列名称": "Campaign Name",
  "ocean-bi:广告组名称": "Ad group name",
  "ocean-bi:广告花费占比": "Advertising spending accounted for",
  "ocean-bi:广告账户账号": "Advertising Account Number",
  "ocean-bi:广告费用": "Advertising costs",
  "ocean-bi:广告销额": "Advertising sales volume",
  "ocean-bi:店铺id": "店铺id",
  "ocean-bi:总子订单数": "The total number of sub-orders",
  "ocean-bi:总订单数": "The total number of orders",
  "ocean-bi:拒付金额": "Chargeback",
  "ocean-bi:拒付金额占比": "Chargeback accounting",
  "ocean-bi:支付-妥投20天子订单数": "Payment - 20 Tuotou emperor orders",
  "ocean-bi:支付-妥投20天子订单数占比": "Pay - Tuotou emperor number of orders accounted for 20",
  "ocean-bi:支付-妥投30天子订单数": "Pay --30 emperor number of orders Tuotou",
  "ocean-bi:支付-妥投30天子订单数占比": "Pay --30 emperor number of orders accounted Tuotou",
  "ocean-bi:支付日期": "Payment date",
  "ocean-bi:支付月份": "Payment of the month",
  "ocean-bi:支付状态": "Payment status",
  "ocean-bi:支付用户数": "Payment users",
  "ocean-bi:收到邮件日期": "Date of receipt of the mail",
  "ocean-bi:未回复数": "No Replies",
  "ocean-bi:物流公司": "Logistics Company",
  "ocean-bi:物流状态": "Logistics state",
  "ocean-bi:站点名称": "Site name",
  "ocean-bi:站点平台": "Site platform",
  "ocean-bi:自然销售额": "Natural sales",
  "ocean-bi:自然销售额占比": "Natural sales accounting",
  "ocean-bi:落地页浏览量": "Landing page views",
  "ocean-bi:订单号": "order number",
  "ocean-bi:订单支付日期": "Order payment date",
  "ocean-bi:订单支付月份": "Orders month pay",
  "ocean-bi:访问客户数": "Access to customer number",
  "ocean-bi:超48小时回复数": "Super 48 hours Replies",
  "ocean-bi:转化率": "Conversion rate",
  "ocean-bi:运费退款金额": "Freight refund amount",
  "ocean-bi:连带率": "Joint rate",
  "ocean-bi:退款原因": "reason for return",
  "ocean-bi:退款日期": "Refund Date",
  "ocean-bi:退款月份": "Refund month",
  "ocean-bi:退款率": "Refund rate",
  "ocean-bi:退款类型": "Refund type",
  "ocean-bi:退款金额": "Refund Amount",
  "ocean-bi:邮件id": "邮件id",
  "ocean-bi:邮件类型": "Mail type",
  "ocean-bi:销售金额": "Sales Amount",
  "ocean-bi:错误信息": "错误信息",
  "ocean-bi:非付费销售额": "Non-paid sales",
  "ocean-bi:非付费销售额占比": "Non-paid sales accounting",
  "OPERATE_GUIDE_TITLE_CANT_BE_SAME": "The same title already exists at the same level",
  "OPERATE_TIMEOUT": "The operation timed out, please try again later",
  "ORDER_C_CANCEL_FAIL": "c end failure orders canceled",
  "ORDER_C_DELIVERY_FAIL": "c stream end fails to complete Tuotou",
  "ORDER_CREATE_FULFILLMENT_FAIL": "C create end logistics delivery failure",
  "order_export_data_is_empty": "Exporting data is empty",
  "order_export_data_is_too_big": "Export data overload",
  "ORDER_EXPORT_FAILED": "Export Failed",
  "ORDER_ITEM_NOT_FOUND": "Child order does not exist",
  "order_item_update_status_fail": "Sub-order status update failure",
  "ORDER_NOT_CANCEL": "Only pay for an order to be allowed to cancel",
  "ORDER_NOT_FOUND": "订单不存在 %s",
  "ORDER_NOT_HAS": "Order number does not exist",
  "ORDER_NOT_ORDER_NO": "c source end order number is empty, you can not cancel the order c end",
  "ORDER_NOT_SUBORDER_ID_EMPTY": "Delivery child order id can not be empty",
  "order_param_all_exist": "All updates and partial updates can not choose",
  "order_product_sku_qty_is_short": "SKU (%s) 库存不足，发货失败",
  "outstock_stocktype_is_exit": "The same type library, please rename!",
  "PARAM_ERROR": "Parameter error",
  "PARAM_FAIL": "参数错误,请检查参数:%s",
  "PARAM_INVALID": "Invalid argument",
  "PASSWORD_ERROR": "wrong password!",
  "performance-analysis::barCharts_receiveRate": "Tuotou rate",
  "performance-analysis::barCharts_sendRate": "Delivery rate",
  "performance-analysis::barCharts_title": "Monthly performance statistics",
  "performance-analysis::cost_title": "The total cost accounting",
  "performance-analysis::cost_tooltip": "The formula: logistics costs / sales amount",
  "performance-analysis::fiveSend_title": "5 days delivery rate",
  "performance-analysis::fiveSend_tooltip": "The formula: the number of orders shipped / total number of orders",
  "performance-analysis::internet_title": "Internet rate",
  "performance-analysis::internet_tooltip": "The formula: the number of Internet orders / total number of orders",
  "performance-analysis::orderDate": "Order payment date",
  "performance-analysis::receive::table_pay20order": "Payment - 20 Tuotou emperor orders",
  "performance-analysis::receive::table_pay20orderRate": "Pay - Tuotou 20 days accounted for",
  "performance-analysis::receive::table_pay30order": "Pay --30 emperor number of orders Tuotou",
  "performance-analysis::receive::table_pay30orderRate": "Pay - Tuotou 30 days accounted for",
  "performance-analysis::receive::table_send20order": "Delivery - 20 Tuotou emperor orders",
  "performance-analysis::receive::table_send20orderRate": "Delivery - Tuotou 20 days accounted for",
  "performance-analysis::receive::table_send30order": "Delivery --30 emperor number of orders Tuotou",
  "performance-analysis::receive::table_send30orderRate": "Delivery - Tuotou 30 days accounted for",
  "performance-analysis::receive::table_shopName": "Store Name",
  "performance-analysis::receive::table_title": "Each store Tuotou case",
  "performance-analysis::send::table_fifteenSendOrder": "The number of orders shipped more than 15 days",
  "performance-analysis::send::table_fifteenSendRate": "More than 15 days delivery rate",
  "performance-analysis::send::table_fiveSendOrder": "0-5 days delivery order number",
  "performance-analysis::send::table_fiveSendRate": "0-5 days delivery rate",
  "performance-analysis::send::table_notSend": "Unfilled orders",
  "performance-analysis::send::table_order": "quantity of order",
  "performance-analysis::send::table_shopName": "Store Name",
  "performance-analysis::send::table_tenSendOrder": "10-15 days delivery order number",
  "performance-analysis::send::table_tenSendRate": "10-15 days delivery rate",
  "performance-analysis::send::table_title": "Each store shipments",
  "performance-analysis::shopName": "Store Name",
  "performance-analysis::thirtyReceive_title": "30 days Tuotou rate",
  "performance-analysis::thirtyReceive_tooltip": "The formula is: Tuotou orders / total number of orders",
  "performance-board::addBuy::table_both": "At the same time plus purchase",
  "performance-board::addBuy::table_bothRate": "At the same time plus purchase accounting",
  "performance-board::addBuy::table_goodsOne": "1 plus the number of users purchase goods",
  "performance-board::addBuy::table_goodsTwo": "Product 2 plus the number of available users",
  "performance-board::addBuy::tip": "The behavior analysis module only has site data whose platform is shoplus, and the additional purchase behavior analysis is its extended function. If you need to use it, please contact customer service.<br /> Statistics of the additional purchases of products in the shopping cart by users during the selected time period can be used as a reference for marketing strategies and recommendations.",
  "performance-board::addBuy::title": "Plus purchase behavior analysis",
  "performance-board::data::areaSoure_title": "Visitors region Source",
  "performance-board::data::changeRate_title": "Conversion rate",
  "performance-board::data::changeRate_tooltip": "The formula is: payment users / number of unique visitors",
  "performance-board::data::funnel_clientCnt": "Number of unique visitors",
  "performance-board::data::funnel_pageUV": "UV superiors page",
  "performance-board::data::funnel_stationUV": "The station UV",
  "performance-board::data::funnel_title": "The conversion funnel",
  "performance-board::data::funnel_transRate": "Conversion rate",
  "performance-board::data::funnel_transRateRatio": "MoM",
  "performance-board::data::outRate_title": "Bounce Rate",
  "performance-board::data::outRate_tooltip": "The number of sessions to exit the browser single page / total number of sessions",
  "performance-board::data::pageVisitor_clientCnt": "Number of unique visitors",
  "performance-board::data::pageVisitor_outRate": "Bounce Rate",
  "performance-board::data::pageVisitor_pageName": "Page name",
  "performance-board::data::pageVisitor_pageType": "Page type",
  "performance-board::data::pageVisitor_title": "Overview page views",
  "performance-board::data::pageVisitor_visitorNum": "Views",
  "performance-board::data::pageVisitor_visitorTime": "Per capita long while browsing (minutes)",
  "performance-board::data::tip": "Behavior analysis module is only a platform for shoplus site data",
  "performance-board::data::title": "Data Overview",
  "performance-board::data::utm_sign": "UTM logo",
  "performance-board::data::utmSource_title": "Visitors UTM Source",
  "performance-board::data::visitor_title": "Number of unique visitors",
  "performance-board::data::visitor_tooltip": "Heavy users to access the site during the selected time",
  "performance-board::data::visitorTime_title": "Per capita long while browsing (minutes)",
  "performance-board::data::visitorTime_tooltip": "The total duration of unique visitors browse the site / unique visitors",
  "performance-board::goods_detail": "product details",
  "performance-board::orderDate": "Order payment date",
  "performance-board::search::table_clickOne": "Items 1 Clicks",
  "performance-board::search::table_clickThree": "Product 3 clicks",
  "performance-board::search::table_clickTwo": "Product 2 clicks",
  "performance-board::search::table_keyWord": "Key words",
  "performance-board::search::table_searchResult": "Number of search results",
  "performance-board::search::table_searchTime": "Searches",
  "performance-board::search::tip": "The behavior analysis module only has site data whose platform is shoplus, and search behavior analysis is its extended function. If you need to use it, please contact customer service.<br /> Count the top 50 keywords most frequently searched by users during the selected period, as well as the top three products and the number of clicks that have been clicked the most after searching for this keyword.",
  "performance-board::search::title": "Search behavior analysis",
  "performance-board::shopName": "Store Name",
  "permission_error": "Permissions abnormal",
  "PHONE_ALREADY_EXIST": "Current phone number has been registered",
  "PHONE_EMAIL_ALREADY_BIND_WECHAT": "The phone number has been bound micro letter",
  "placeholder_errorPhone": "Phone number format is incorrect",
  "PLATFORM_SITE_PARAM_ERROR": "platformSite field is not legitimate",
  "please_binding_logistics": "Please Binding logistics providers",
  "PORTAL_EMAIL_EXIT": "The mailbox already exists, replace the mailbox",
  "PORTAL_USER_AUDIT_STATUS_ERROR": "User Audit abnormal state",
  "PORTAL_USER_EXTEND_NOT_FOUND": "The user does not correspond to the package",
  "PORTAL_USER_NOT_FOUND": "Audit abnormal state",
  "product_category_has_child_delete": "The presence of the heads of such sub-categories can not be deleted!",
  "product_category_has_child_edit": "The presence of sub-categories that category is not allowed to modify the parent category",
  "product_category_no_change": "Category not changed, without modification!",
  "product_category_rename": "The same category name, rename!",
  "PRODUCT_NOT_FOUND": "Product not found",
  "product_option_exist": "The property does not exist",
  "product_option_rename": "The attribute name already exists, please rename!",
  "product_option_value_exist": "The attribute value does not exist",
  "product_option_value_rename": "The attribute value name already exists, please rename!",
  "PRODUCT_PUBLISH_ERROR": "推送店铺端失败,原因：%s",
  "product_supplier_rename": "The vendor name already exists, please rename!",
  "product_tag_rename": "The label name already exists, please rename!",
  "product-manager::category::add_button": "Add category",
  "product-manager::category::add_child_dialog": "Add sub category",
  "product-manager::category::add_dialog": "Add category",
  "product-manager::category::delete_tip": "After deleting the data can not be recovered",
  "product-manager::category::delete_title": "Confirm delete this category yet?",
  "product-manager::category::edit_dialog": "Edit Category",
  "product-manager::category::form_father": "Parent Category",
  "product-manager::category::form_name": "Category Name",
  "product-manager::category::placeholder_father": "Enter the parent category",
  "product-manager::category::placeholder_name": "Please enter the category name",
  "product-manager::category::placeholder_search": "Please enter the category name",
  "product-manager::category::search": "Category Name",
  "product-manager::category::table_add": "Add sub",
  "product-manager::category::table_delete": "delete",
  "product-manager::category::table_edit": "edit",
  "product-manager::category::table_handle": "operating",
  "product-manager::category::table_name": "Category Name",
  "product-manager::prop_value::add_button": "New property values",
  "product-manager::prop_value::placeholder_name": "Please enter the attribute values",
  "product-manager::prop_value::table_creatTime": "Created",
  "product-manager::prop_value::table_name": "Property Value Name",
  "product-manager::prop_value::table_no": "No.",
  "product-manager::prop::add_button": "New Properties",
  "product-manager::prop::add_title": "New Properties",
  "product-manager::prop::custom_prop": "Custom Attributes",
  "product-manager::prop::delete_tip": "This will delete the item, whether to continue?",
  "product-manager::prop::edit_button": "Edit Properties",
  "product-manager::prop::edit_title": "Edit Properties",
  "product-manager::prop::placeholder_prop_name": "Please enter the attribute name",
  "product-manager::prop::placeholder_search": "Please enter the attribute name",
  "product-manager::prop::prop_name": "Property Name",
  "product-manager::prop::search": "Property Name",
  "product-manager::prop::table_creatTime": "Created",
  "product-manager::prop::table_delete": "delete",
  "product-manager::prop::table_edit": "edit",
  "product-manager::prop::table_handle": "operating",
  "product-manager::prop::table_name": "Property Name",
  "product-manager::prop::table_no": "No.",
  "product-manager::prop::table_prop": "Property Value",
  "product-manager::prop::table_type": "Property type",
  "product-manager::prop::tooltip_prop": "Custom properties are not limited attribute value",
  "product-manager::prop::trigger_prop": "Non-custom properties",
  "product-manager::tabs_category": "Product categories",
  "product-manager::tabs_prop": "Commercial Property",
  "product-manager::tabs_tag": "Goods Tag",
  "product-manager::tag::add_button": "New Label",
  "product-manager::tag::edit_button": "Edit Labels",
  "product-manager::tag::form_name": "Label name",
  "product-manager::tag::placeholder_name": "Please enter the label name",
  "product-manager::tag::placeholder_search": "Please enter the label name",
  "product-manager::tag::search": "Label name",
  "product-manager::tag::table_createTime": "Created",
  "product-manager::tag::table_delete": "delete",
  "product-manager::tag::table_edit": "edit",
  "product-manager::tag::table_handle": "operating",
  "product-manager::tag::table_name": "Label name",
  "product-manager::tag::table_no": "No.",
  "purchase_item_is_not_exit": "PO does not exist, audit failures",
  "purchase::purchase-list::add_sku": "Add SKU",
  "purchase::purchase-list::add_success": "Added successfully",
  "purchase::purchase-list::add_supplier": "New Purchase Order",
  "purchase::purchase-list::all_arrival": "All arrival",
  "purchase::purchase-list::amount": "Quantity",
  "purchase::purchase-list::arrival_amount": "The number of arrival",
  "purchase::purchase-list::audit": "Check",
  "purchase::purchase-list::audit_confirm": "The audit confirmed purchase order it?",
  "purchase::purchase-list::audit_time": "Review time",
  "purchase::purchase-list::auditor": "Reviewer",
  "purchase::purchase-list::autit_info": "Audit information",
  "purchase::purchase-list::begin_time": "Starting time",
  "purchase::purchase-list::cancel": "cancel",
  "purchase::purchase-list::check_all": "Select All",
  "purchase::purchase-list::close": "shut down",
  "purchase::purchase-list::close_confirm": "After close can not be restored! !",
  "purchase::purchase-list::close_purchase_order": "OK to close the purchase order it?",
  "purchase::purchase-list::closed": "closed",
  "purchase::purchase-list::confirm": "determine",
  "purchase::purchase-list::create_info": "Creating information",
  "purchase::purchase-list::create_time": "Created",
  "purchase::purchase-list::creator": "founder",
  "purchase::purchase-list::date_input": "Please enter the planned arrival date",
  "purchase::purchase-list::date_select": "Select Date",
  "purchase::purchase-list::delete": "delete",
  "purchase::purchase-list::delete_confirm": "Once deleted can not be recovered! !",
  "purchase::purchase-list::detail": "Detail",
  "purchase::purchase-list::edit": "edit",
  "purchase::purchase-list::end_time": "End Time",
  "purchase::purchase-list::finished": "completed",
  "purchase::purchase-list::has_audit": "Audited",
  "purchase::purchase-list::has_re_audit": "It has been reviewed",
  "purchase::purchase-list::in_stock": "Warehousing",
  "purchase::purchase-list::in_stock_this_time": "The storage",
  "purchase::purchase-list::in_stock_this_time_num": "Please enter the number of this storage",
  "purchase::purchase-list::input_holder": "Please enter content",
  "purchase::purchase-list::no_data": "No data",
  "purchase::purchase-list::opt": "operating",
  "purchase::purchase-list::order": "purchase order",
  "purchase::purchase-list::order_num": "Single number",
  "purchase::purchase-list::partial_arrival": "Section arrival",
  "purchase::purchase-list::plan_arrival_date": "Planned arrival date",
  "purchase::purchase-list::please_add_sku": "Please add purchase sku",
  "purchase::purchase-list::please_select": "please choose",
  "purchase::purchase-list::price_equal": "Default unit price = commodity cost",
  "purchase::purchase-list::price_input": "Please enter the unit price",
  "purchase::purchase-list::product_info": "Product information",
  "purchase::purchase-list::product_name": "product name",
  "purchase::purchase-list::progress": "schedule",
  "purchase::purchase-list::puechase_order_num": "Purchase Order No",
  "purchase::purchase-list::purchase_amount": "Purchase quantity",
  "purchase::purchase-list::purchase_delete": "Confirm to delete the purchase order it?",
  "purchase::purchase-list::purchase_detail": "Purchasing Details",
  "purchase::purchase-list::purchase_finished": "Confirm that it has completed the purchase order?",
  "purchase::purchase-list::purchase_in_stock": "Procurement of storage",
  "purchase::purchase-list::purchase_price": "Purchase amount (¥)",
  "purchase::purchase-list::purchase_price_input": "Enter freight procurement",
  "purchase::purchase-list::purchase_shipping": "Purchasing Freight",
  "purchase::purchase-list::purchse_total_amount": "Total amount of purchases",
  "purchase::purchase-list::quick_sort": "Rapid screening",
  "purchase::purchase-list::re_audit": "review",
  "purchase::purchase-list::re_audit_confirm": "The review confirmed purchase order it?",
  "purchase::purchase-list::re_audit_info": "Review information",
  "purchase::purchase-list::re_audit_time": "Review time",
  "purchase::purchase-list::re_auditor": "Reviewer",
  "purchase::purchase-list::remark": "Remark",
  "purchase::purchase-list::return_order": "Return purchase order",
  "purchase::purchase-list::return_order_edit": "Return purchase order",
  "purchase::purchase-list::return_purchase_order": "Return purchase order",
  "purchase::purchase-list::save": "save",
  "purchase::purchase-list::save_audit": "Save and review",
  "purchase::purchase-list::setting_confirm": "Set will not be put in storage has been completed",
  "purchase::purchase-list::single_price": "Price (¥)",
  "purchase::purchase-list::sku": "SKU",
  "purchase::purchase-list::sku_delete_confirm": "The SKU sure to delete it?",
  "purchase::purchase-list::status": "status",
  "purchase::purchase-list::supplier": "supplier",
  "purchase::purchase-list::supplier_input": "Please enter supplier",
  "purchase::purchase-list::total": "Subtotal",
  "purchase::purchase-list::total_amount": "The total amount (¥)",
  "purchase::purchase-list::total_input": "Enter the total amount",
  "purchase::purchase-list::wait_audit": "Pending",
  "refund_custom_tag_rename": "The sale property name already exists, please rename!",
  "refund_order_is_exist": "The order number corresponds to an existing single sale",
  "refund_order_no_not_null": "Order number can not be empty",
  "refund_reason_delete_has_children": "The current reason for deletion after-sale subordinates can not be deleted!",
  "refund_reason_has_children": "The current editor aftermarket reasons are lower, you can not be edited!",
  "refund_reason_merchant_id_different": "The current operation objects and create objects inconsistent!",
  "refund_reason_rename": "Aftermarket same reason, rename!",
  "refund_remain_amount_error": "Refund amount greater than the amount of the refund",
  "refund_same_level": "Two reasons for not linked to the two reasons",
  "refund_transaction_fail": "Refund failed",
  "refund_update_status_fail": "Failed to update order status",
  "RPC_TRANSFER_EXCEPTION": "Remote service call fails",
  "sale-analysis::changeRatio_title": "Conversion rate",
  "sale-analysis::changeRatio_tooltip": "Store platform is the only conversion rate shoplus corresponding,<br/> The formula is: payment users / number of unique visitors",
  "sale-analysis::orderDate": "Order payment date",
  "sale-analysis::orderPrice_title": "Customer price",
  "sale-analysis::orderPrice_tooltip": "The formula is: sales / orders have been paid",
  "sale-analysis::sales_title": "Sales",
  "sale-analysis::sales_tooltip": "The actual payment amount has been paid corresponding to the order",
  "sale-analysis::sales::table_associateRate": "Joint rate",
  "sale-analysis::sales::table_customerPricePer": "Customer price",
  "sale-analysis::sales::table_img": "product picture",
  "sale-analysis::sales::table_name": "Commodity Sales Overview",
  "sale-analysis::sales::table_receiveOkMoney": "Tuotou amount",
  "sale-analysis::sales::table_refundMoney": "Refund Amount",
  "sale-analysis::sales::table_refundRatio": "Refund rate",
  "sale-analysis::sales::table_salesMoney": "Sales Amount",
  "sale-analysis::sales::table_salesNum": "Sales",
  "sale-analysis::shopName": "Store Name",
  "sale-analysis::station::table_associateRate": "Joint rate",
  "sale-analysis::station::table_changeRatio": "Conversion rate",
  "sale-analysis::station::table_customerPricePer": "Customer price",
  "sale-analysis::station::table_name": "Overview of the site management",
  "sale-analysis::station::table_sales": "Sales",
  "sale-analysis::station::table_salesRatio": "Sales accounting",
  "sale-analysis::station::table_shopName": "Store Name",
  "sale-analysis::station::table_shopType": "Site Type",
  "sale-analysis::station::table_visitor": "Access to customer number",
  "sale-analysis::trend::charts_bar": "Turnover",
  "sale-analysis::trend::charts_line": "Customer price",
  "sale-analysis::trend::charts_title": "Overall turnover trend",
  "sale-analysis::visitorNum_title": "Number of unique visitors",
  "sale-analysis::visitorNum_tooltip": "Platform is the only shop shoplus corresponding number of unique visitors,<br/> That is, the number of users within a selected time to re-visit site",
  "sale-order::intervalTime_tip": "There are currently selected time range as of {money} {currency} refund, the number of days were accounted",
  "sale-order::intervalTime_title": "Pay for an order to refund the interval statistics",
  "sale-order::line::money": "Money",
  "sale-order::orderDate": "Order payment date",
  "sale-order::protestMoney_title": "Chargeback",
  "sale-order::refund::table_country": "country",
  "sale-order::refund::table_img": "product picture",
  "sale-order::refund::table_protest": "Chargeback",
  "sale-order::refund::table_protestRate": "Chargeback accounting",
  "sale-order::refund::table_recieve": "Tuotou amount",
  "sale-order::refund::table_refund": "Refund Amount",
  "sale-order::refund::table_refundRate": "Refund rate",
  "sale-order::refund::table_sales": "Sales Amount",
  "sale-order::refund::table_selfRefund": "Initiative refund amount",
  "sale-order::refund::table_selfRefundRate": "Refund Amount Percentage initiative",
  "sale-order::refundcountry_title": "Refund National Statistics",
  "sale-order::refundDate": "Refund Time",
  "sale-order::refundGoods_title": "Refund Commodity Statistics",
  "sale-order::refundMoney_title": "Refund Amount",
  "sale-order::refundRate_title": "Refund rate",
  "sale-order::refundRate_tooltip": "The formula: the amount of the refund / sales amount",
  "sale-order::refundReason_title": "Return Reason accounting",
  "sale-order::returnGoods_title": "Returns number of items",
  "sale-order::returnGoods_tooltip": "The current number of paid goods orders as of refund",
  "sale-order::returnMoney_title": "Refund Amount",
  "sale-order::returnMoney_tooltip": "By the amount of the refund paid orders generated by the current initiative to refund the amount of the chargeback +",
  "sale-order::sales_title": "Sales Amount",
  "sale-order::sales_tooltip": "The total amount paid orders actually paid the corresponding",
  "sale-order::selfRefundMoney_title": "Initiative refund amount",
  "sale-order::shopName": "Store Name",
  "SEND_EMAIL_ERROR": "邮件验证码发送异常:%s",
  "SERVICE_INVOKE_FAIL": "（%s）服务调用失败",
  "SHOP_CHECK_ERROR": "Authentication failed, please check the accuracy of all information",
  "SHOP_CSHOP_HAS_BEEN_BOUND": "The shop has been bound c end, please find the corresponding merchant authorization",
  "SHOP_DOMAIN_REPEAT": "The platform has been binding domain, do not repeat binding!",
  "SHOP_NAME_REPEAT": "店铺名称已经存在(%s)！",
  "SHOP_NOT_FOUND": "店铺（%s）不存在",
  "SHOP_OFFLINE": "Enabled shop was not found",
  "SHOP_SPU_NO_PRODUCT_ID": "spu not associated with c-side shop, check whether to issue a success",
  "SHOP_SPU_NOT_FOUND": "The shop did not publish this item",
  "SHOP_TASK_RUNNING": "Store task execution!",
  "SHOP_WEBHOOK_CREATE_ERROR": "创建店铺webhook失败,原因:%s",
  "SHOP_WEBHOOK_DELETE_ERROR": "删除店铺webhook失败,原因:%s",
  "shop-site::campaign_rules::example": "Example: ad_test2nd5c01_none_0000_0415_10002_ {name} optimizers",
  "shop-site::campaign_rules::key_title": "Support key",
  "shop-site::campaign_rules::placeholder": "Please enter a rule, separated by _",
  "shop-site::campaign_rules::staff_button": "{Name} optimizers",
  "shop-site::campaign_rules::tip": "Use underscores segmentation",
  "shop-site::campaign_rules::title": "campaign rules",
  "shop-site::email::add_button": "New Mailbox",
  "shop-site::email::addEmail_title": "New Mailbox",
  "shop-site::email::auth_tip": "Obtain authorization code",
  "shop-site::email::confirm_agian": "reconnect",
  "shop-site::email::confirm_return": "Return to Edit",
  "shop-site::email::confirm_title": "Connection failed",
  "shop-site::email::editEmail_title": "E-mail editor",
  "shop-site::email::form_account": "email address",
  "shop-site::email::form_password": "email Password",
  "shop-site::email::form_platform": "platform",
  "shop-site::email::form_staff": "principal",
  "shop-site::email::moreSetting": "advanced settings",
  "shop-site::email::placeholder_account": "Please enter mail account",
  "shop-site::email::placeholder_emailAddress": "Please enter the server address",
  "shop-site::email::placeholder_emailPort": "Enter the server port number",
  "shop-site::email::placeholder_emailType": "Select Server Type",
  "shop-site::email::placeholder_password": "Please enter the email password",
  "shop-site::email::placeholder_platform": "Choose platform",
  "shop-site::email::placeholder_protocol": "Please select the transmission encryption protocol",
  "shop-site::email::placeholder_rightAccount": "Please enter a valid email",
  "shop-site::email::placeholder_shop": "Please select a store",
  "shop-site::email::placeholder_staff": "Please select the person in charge",
  "shop-site::email::qq_tip": "QQ-mail, please enter the following link",
  "shop-site::email::recieveSetting": "Write Configuration",
  "shop-site::email::search_placeholder": "Search E-mail address",
  "shop-site::email::sendSetting": "Configuration sender",
  "shop-site::email::table_createTime": "Created",
  "shop-site::email::table_edit": "edit",
  "shop-site::email::table_emailSign": "Mail Signature",
  "shop-site::email::table_handle": "operating",
  "shop-site::email::table_no": "No.",
  "shop-site::email::table_off": "Disable",
  "shop-site::email::table_on": "Enable",
  "shop-site::email::table_protocol": "Transmission encryption protocol",
  "shop-site::email::table_recieve": "Write information",
  "shop-site::email::table_recieveAddress": "Incoming mail server address",
  "shop-site::email::table_recievePort": "Incoming mail server port",
  "shop-site::email::table_reciever": "Addressee",
  "shop-site::email::table_recieveType": "Incoming Mail Server Type",
  "shop-site::email::table_send": "Outgoing information",
  "shop-site::email::table_sendAddress": "Outgoing server address",
  "shop-site::email::table_sender": "Sender",
  "shop-site::email::table_sendPort": "Outgoing server port",
  "shop-site::email::table_sendType": "Outgoing server type",
  "shop-site::email::table_shop": "Shop",
  "shop-site::email::table_status": "status",
  "shop-site::email::table_time": "time",
  "shop-site::email::table_updateTime": "Updated",
  "shop-site::emailSign::form_content": "Signed Content",
  "shop-site::emailSign::form_email": "E-mail Accounts",
  "shop-site::emailSign::form_turn": "Whether to enable",
  "shop-site::emailSign::placeholder_content": "Rich Text box: Contents",
  "shop-site::emailSign::title": "Mail Signature",
  "shop-site::empty::ad_bind_facebook": "Binding Facebook account",
  "shop-site::empty::ad_tips": "Binds You can understand in real-time Facebook / Google advertising effectiveness",
  "shop-site::empty::ad_title": "You are not binding advertising and marketing account",
  "shop-site::empty::bind_logi": "Immediately set",
  "shop-site::empty::logi_tips": "Setting logistics providers can achieve rapid delivery, get smart transport solutions recommended",
  "shop-site::empty::logi_title": "You have not set logistics providers",
  "shop-site::facebook_campaign::add_staff": "Add optimizers",
  "shop-site::facebook_campaign::bind_title": "Binding campaign",
  "shop-site::facebook_campaign::campaign_name": "campaign logo",
  "shop-site::facebook_campaign::placeholder_campaign_name": "Please enter the campaign logo",
  "shop-site::facebook_campaign::placeholder_staff_name": "Please enter the name optimizers",
  "shop-site::facebook_campaign::staff_name": "Optimizers name",
  "shop-site::facebook_campaign::tooltip_campaign_name": "For matching optimizers and campaign",
  "shop-site::facebook_campaign::upload_avatar": "Upload Avatar",
  "shop-site::facebook_campaign::upload_avatar_tip": "Note: If you do not use the default upload an avatar picture",
  "shop-site::facebook_campaign::upload_title": "upload image",
  "shop-site::facebook_token::add_button": "New configuration",
  "shop-site::facebook_token::placeholder_name": "Please enter a name",
  "shop-site::facebook_token::placeholder_token": "Please enter the Token",
  "shop-site::facebook_token::table_cancel": "cancel",
  "shop-site::facebook_token::table_edit": "edit",
  "shop-site::facebook_token::table_handle": "operating",
  "shop-site::facebook_token::table_name": "name",
  "shop-site::facebook_token::table_save": "save",
  "shop-site::facebook_token::table_time": "time",
  "shop-site::facebook_token::table_token": "Token",
  "shop-site::facebook_token::tip": "Manage your Facebook advertising account, support the pull of advertising data and marketing expenses, so that you can analyze the effectiveness of your advertising. Add the token information related to your advertising account in the following configuration to complete the pull of advertising data and perform performance analysis in the advertising data board.",
  "shop-site::facebook_token::title": "Token Configuration",
  "shop-site::facebook::add_title": "New Account",
  "shop-site::facebook::button_new": "Add Facebook Account",
  "shop-site::facebook::button_staff": "Configuration optimization division",
  "shop-site::facebook::button_token": "Token Configuration",
  "shop-site::facebook::dialog_bind": "Unbinding",
  "shop-site::facebook::dialog_noData": "No data check",
  "shop-site::facebook::edit_title": "Edit Account",
  "shop-site::facebook::placeholder_account": "Please enter the account name",
  "shop-site::facebook::placeholder_accountId": "Please enter the account ID",
  "shop-site::facebook::placeholder_number": "Please key in numbers",
  "shop-site::facebook::placeholder_search": "Search Facebook name or ID",
  "shop-site::facebook::placeholder_searchShop": "Search Store",
  "shop-site::facebook::placeholder_shop": "Please select a store",
  "shop-site::facebook::placeholder_token": "Choose Token Configuration",
  "shop-site::facebook::table_account": "Account Name",
  "shop-site::facebook::table_accountId": "Account ID",
  "shop-site::facebook::table_compaign": "Campaign rules",
  "shop-site::facebook::table_creatTime": "Created",
  "shop-site::facebook::table_edit": "edit",
  "shop-site::facebook::table_handle": "operating",
  "shop-site::facebook::table_no": "No.",
  "shop-site::facebook::table_off": "Disable",
  "shop-site::facebook::table_on": "Enable",
  "shop-site::facebook::table_shop": "Shop",
  "shop-site::facebook::table_status": "status",
  "shop-site::facebook::table_time": "time",
  "shop-site::facebook::table_updateTime": "Updated",
  "shop-site::facebook::tip": "How to get Facebook account ID and name?",
  "shop-site::facebook::tooltip_compaign": "The campaign and optimizers for trafficking case binding, and can be used to optimize the analysis division",
  "shop-site::google_manager::add_button": "New Account Manager",
  "shop-site::google_manager::add_title": "New Account",
  "shop-site::google_manager::dialog_bind": "Unbinding",
  "shop-site::google_manager::dialog_noData": "No data check",
  "shop-site::google_manager::edit_title": "Edit Account",
  "shop-site::google_manager::placeholder_accountId": "Please select the Google account manager ID",
  "shop-site::google_manager::placeholder_customerId": "Enter the sub-account ID",
  "shop-site::google_manager::table_account": "Manager account ID",
  "shop-site::google_manager::table_edit": "edit",
  "shop-site::google_manager::table_hanlde": "operating",
  "shop-site::google_manager::table_token": "Developer Token",
  "shop-site::google_manager::title": "Google account manager",
  "shop-site::google::add_button": "New Google Account",
  "shop-site::google::addManager_button": "Google account manager",
  "shop-site::google::edit_button": "New Google Account",
  "shop-site::google::form_managerId": "Google manager ID",
  "shop-site::google::form_official": "formal",
  "shop-site::google::form_serverId": "Client ID",
  "shop-site::google::form_serverSecret": "Client Secret",
  "shop-site::google::form_token": "Developer Token",
  "shop-site::google::form_unofficial": "Unofficial",
  "shop-site::google::placeholder_managerId": "Please enter a Google account manager ID",
  "shop-site::google::placeholder_refreshToken": "Please enter RefreshToken",
  "shop-site::google::placeholder_releaseStatus": "Please enter ReleaseStatus",
  "shop-site::google::placeholder_search": "Enter the manager account or sub-account ID ID",
  "shop-site::google::placeholder_searchShop": "Please select a store",
  "shop-site::google::placeholder_serverId": "Please enter the Client ID",
  "shop-site::google::placeholder_serverSecret": "Please enter the Client Secret",
  "shop-site::google::placeholder_token": "Please enter the developer token",
  "shop-site::google::table_child": "Valley Utako account ID",
  "shop-site::google::table_creatTime": "Created",
  "shop-site::google::table_edit": "edit",
  "shop-site::google::table_handle": "operating",
  "shop-site::google::table_manager": "Google manager account ID",
  "shop-site::google::table_no": "No.",
  "shop-site::google::table_off": "Disable",
  "shop-site::google::table_on": "Enable",
  "shop-site::google::table_shop": "Shop",
  "shop-site::google::table_status": "status",
  "shop-site::logistics::add_button": "New logistics providers",
  "shop-site::logistics::add_title": "New logistics providers",
  "shop-site::logistics::delete_tip": "Deleting it can not recommend the logistics provider for your optimal way logistics and price inquiry",
  "shop-site::logistics::delete_title": "Delete the logistics business",
  "shop-site::logistics::placeholder_apiKey": "Please enter Api Key",
  "shop-site::logistics::placeholder_apiSecret": "Please enter Api Secret",
  "shop-site::logistics::placeholder_name": "Please select the logistics business",
  "shop-site::logistics::placeholder_search": "Search logistics business name",
  "shop-site::logistics::placeholder_tip": "Verification fails, please check the accuracy of the key",
  "shop-site::logistics::table_apiKey": "API Key",
  "shop-site::logistics::table_apiSecret": "API Secret",
  "shop-site::logistics::table_handle": "operating",
  "shop-site::logistics::table_name": "Logistics providers",
  "shop-site::logistics::tip": "How to Obtain API Key and key logistics providers?",
  "shop-site::paySetting::add_button": "New Account",
  "shop-site::paySetting::edit_button": "Edit Account",
  "shop-site::paySetting::placeholder_account": "Please enter the receiving account",
  "shop-site::paySetting::placeholder_accountId": "Please enter the receiving account ID",
  "shop-site::paySetting::placeholder_accountName": "Please enter the account referred to",
  "shop-site::paySetting::placeholder_apiName": "Enter the API Username",
  "shop-site::paySetting::placeholder_apiSecret": "Please enter the API password",
  "shop-site::paySetting::placeholder_apiSign": "Please enter an API signature",
  "shop-site::paySetting::placeholder_paypalAccount": "Please enter paypalAccount",
  "shop-site::paySetting::placeholder_paypalSecret": "Please enter paypalSecret",
  "shop-site::paySetting::placeholder_search": "Search accounts referred",
  "shop-site::paySetting::placeholder_shop": "Please select a store",
  "shop-site::paySetting::table_account": "Accounts receivable",
  "shop-site::paySetting::table_accountId": "Receiving account id",
  "shop-site::paySetting::table_accountName": "Accounts referred",
  "shop-site::paySetting::table_apiName": "API Username",
  "shop-site::paySetting::table_apiSecret": "API password",
  "shop-site::paySetting::table_apiSign": "API signature",
  "shop-site::paySetting::table_edit": "edit",
  "shop-site::paySetting::table_handle": "operating",
  "shop-site::paySetting::table_shop": "Shop",
  "shop-site::paySetting::tip": "How to get paypal associated keys?",
  "shop-site::tab_email": "Customer Service Email",
  "shop-site::tab_facebook": "Facebook Advertising",
  "shop-site::tab_google": "Google Ads",
  "shop-site::tab_logistics": "Logistics Set",
  "shop-site::tab_paySetting": "Payment settings",
  "SHOPIFY_SITE_CRAWLER_RUN_ERROR": "Triggering reptile failure",
  "SKU_CODE_EXIST": "商品skuCode( %s )已存在",
  "sku_image_is_null": "sku pictures can not be empty",
  "sku_inventory_short": "Sku less than the corresponding inventory, audit failures",
  "SKU_NOT_FOUND": "SKU不存在，skuId:%s",
  "SKU_OPTION_INVALID": "SKU can not add more than the absence of property sales",
  "sku_option_not_match": "SKU的销售属性（%s）和SPU的不匹配",
  "SKU_OPTION_REPEAT": "SKU的销售属性重复(%s)",
  "sku_option_value_not_match": "SKU的销售属性值（%s）和SPU的（%s]]）不匹配",
  "SMS_EVENT_ERROR": "SMS event into the reference error",
  "SMS_EVENT_SEND_DAY_LIMIT_": "The number of text messages sent that day have reached the limit",
  "SMS_EVENT_SEND_HOUR_LIMIT": "SMS too frequently, one hour after retries",
  "SMS_EVENT_SEND_MINUTE_LIMIT": "SMS too frequently, one minute and try again",
  "SMS_LOGIN_USER_EXIT_ERROR": "The account has been registered",
  "SMS_LOGIN_USER_NOT_EXIT_ERROR": "The account is not registered!",
  "SORTBY_PARAM_ERROR": "sortBy field is not legitimate",
  "SPU_CODE_EXIST": "商品spuCode( %s]] )已存在，对应id和名称为%s]] , %s]]",
  "SPU_ID_NOT_EXIST": "skuId( %s )商品不存在",
  "SPU_ID_UP_SHELVES": "spuId( %s )对应商品已下架,不允许发布",
  "spu_image_is_null": "spu picture can not be empty",
  "SPU_NO_SHOP_BIND": "SPU not published to any shop",
  "SPU_NOT_INVENTORY": "skuId:( %s )产品没有库存",
  "SPU_NOT_PRICE": "skuId:( %s )产品没有定价",
  "storage::commodity-stocks::item": "item",
  "storage::commodity-stocks::platform_sku": "Platform SKU",
  "storage::commodity-stocks::platform_table_commodity": "commodity",
  "storage::commodity-stocks::platform_table_commodity_stock": "Commodity stocks",
  "storage::commodity-stocks::platform_table_pat_cost": "Delivery costs (¥)",
  "storage::commodity-stocks::platform_table_pat_cost_tips1": "The cost of service after a single weighted average cost of storage",
  "storage::commodity-stocks::platform_table_pat_cost_tips2": "It may differ from the product information supply costs",
  "storage::commodity-stocks::platform_table_pic": "image",
  "storage::commodity-stocks::platform_table_safe_stock": "Safety stock",
  "storage::commodity-stocks::platform_table_sku": "SKU",
  "storage::commodity-stocks::platform_table_spu": "SPU",
  "storage::commodity-stocks::platform_table_stock": "in stock",
  "storage::commodity-stocks::platform_table_stock_amount": "Inventory valuation (¥)",
  "storage::commodity-stocks::platform_table_stock_equal": "Inventory valuation * = goods inventory supply costs",
  "storage::commodity-stocks::platform_table_supplier": "supplier",
  "storage::commodity-stocks::platform_table_use_stock": "Available inventory",
  "storage::commodity-stocks::platform_total_stock": "The total valuation",
  "storage::commodity-stocks::selected": "chosen",
  "storage::commodity-stocks::stock_flow": "Stock water",
  "storage::commodity-stocks::stock_flow_after_stock": "After the inventory change",
  "storage::commodity-stocks::stock_flow_audited": "Audited",
  "storage::commodity-stocks::stock_flow_before_stock": "Inventory change before",
  "storage::commodity-stocks::stock_flow_bill_code": "Single number",
  "storage::commodity-stocks::stock_flow_change": "Change in value",
  "storage::commodity-stocks::stock_flow_change_time": "Time change",
  "storage::commodity-stocks::stock_flow_close": "shut down",
  "storage::commodity-stocks::stock_flow_closed": "closed",
  "storage::commodity-stocks::stock_flow_product_name": "product name",
  "storage::commodity-stocks::stock_flow_wait_audit": "Pending",
  "storage::commodity-stocks:false": "no",
  "storage::commodity-stocks:no_stock": "Inventory shortage",
  "storage::commodity-stocks:platform_spu": "SPU platform",
  "storage::commodity-stocks:shop_name": "product name",
  "storage::commodity-stocks:supplier": "supplier",
  "storage::commodity-stocks:total_stock": "Total inventory",
  "storage::commodity-stocks:total_stock_amount": "Total inventory valuation",
  "storage::commodity-stocks:true": "Yes",
  "storage::in-stock::add_instock": "New Receipts",
  "storage::in-stock::add_sku": "Add SKU",
  "storage::in-stock::audit_time": "Review time",
  "storage::in-stock::auditor": "Reviewer",
  "storage::in-stock::auditor_select": "Please select reviewer",
  "storage::in-stock::bill": "Receipts",
  "storage::in-stock::bill_num": "Single number",
  "storage::in-stock::bill_num_input": "Please enter a single number",
  "storage::in-stock::cancel": "cancel",
  "storage::in-stock::change_supplier_tips": "Confirm that you want to change suppliers",
  "storage::in-stock::close_instock": "Close Receipts",
  "storage::in-stock::closed": "closed",
  "storage::in-stock::confirm": "determine",
  "storage::in-stock::create_time": "Created",
  "storage::in-stock::creator": "founder",
  "storage::in-stock::creator_select": "Please choose Created",
  "storage::in-stock::detail": "Detail",
  "storage::in-stock::end_time": "End Time",
  "storage::in-stock::export": "Export",
  "storage::in-stock::fullfillment_num": "shipment number",
  "storage::in-stock::has_audit": "Audited",
  "storage::in-stock::import": "Importing",
  "storage::in-stock::import_instock": "Importing Receipt",
  "storage::in-stock::in_type": "Storage type",
  "storage::in-stock::in_type_select": "Please select the type of storage",
  "storage::in-stock::input_holder": "Please enter content",
  "storage::in-stock::instock_amount": "Number storage",
  "storage::in-stock::instock_close_reason": "Closed Reason",
  "storage::in-stock::instock_date": "Warehousing date",
  "storage::in-stock::instock_date_select": "Please select the storage date",
  "storage::in-stock::instock_detail": "Storage Detail",
  "storage::in-stock::instock_num": "Number storage",
  "storage::in-stock::instock_order_num": "Receipt No.",
  "storage::in-stock::instock_type": "Storage type",
  "storage::in-stock::instock_type_add": "Adding storage type",
  "storage::in-stock::order": "Order form",
  "storage::in-stock::order_sku": "SKU",
  "storage::in-stock::please_select": "please choose",
  "storage::in-stock::prod_name": "product name",
  "storage::in-stock::purchase_order": "Purchase Order",
  "storage::in-stock::relate_num": "Relevance No.",
  "storage::in-stock::remark": "Remark",
  "storage::in-stock::save": "save",
  "storage::in-stock::save_audit": "Save and review",
  "storage::in-stock::select_all": "Select All",
  "storage::in-stock::select_date": "Select Date",
  "storage::in-stock::sku_clear_tips": "After switching suppliers emptied SKU list",
  "storage::in-stock::sku_select": "Please continue operating after adding SKU",
  "storage::in-stock::start_time": "Starting time",
  "storage::in-stock::status": "status",
  "storage::in-stock::status_select": "Please select state",
  "storage::in-stock::stock_decrease": "Stock will increase or decrease after review! !",
  "storage::in-stock::stock_decrease_warn": "To perform audits to confirm the operation?",
  "storage::in-stock::supplier": "supplier",
  "storage::in-stock::supplier_select": "Please select suppliers continue to operate",
  "storage::in-stock::supplier_select_holder": "Please select suppliers",
  "storage::in-stock::table_audit": "Check",
  "storage::in-stock::table_audit_time": "Review time",
  "storage::in-stock::table_auditor": "Reviewer",
  "storage::in-stock::table_bill_num": "Single number",
  "storage::in-stock::table_close": "shut down",
  "storage::in-stock::table_create_time": "Created",
  "storage::in-stock::table_creator": "founder",
  "storage::in-stock::table_detail": "Detail",
  "storage::in-stock::table_edit": "edit",
  "storage::in-stock::table_instock_time": "Warehousing date",
  "storage::in-stock::table_opt": "operating",
  "storage::in-stock::table_releate_num": "Relevance No.",
  "storage::in-stock::table_status": "status",
  "storage::in-stock::table_supplier": "supplier",
  "storage::in-stock::table_type": "business type",
  "storage::in-stock::third_bill_num": "No third-party single",
  "storage::in-stock::total_amount": "The total amount (¥)",
  "storage::in-stock::un_audit": "Not reviewed",
  "storage::in-stock::请添加SKU": "Please add SKU",
  "storage::in-stock::请输入数量": "Please enter a quantity",
  "storage::in-stock::请输入正确数量": "Please enter the correct number",
  "storage::in-stock::请输入正确金额": "Please enter the correct amount",
  "storage::in-stock::请输入金额": "Please enter an amount",
  "storage::out-stock::add_add": "determine",
  "storage::out-stock::add_cancel": "cancel",
  "storage::out-stock::add_create_time": "Creation Date",
  "storage::out-stock::add_download": "click to download",
  "storage::out-stock::add_export": "Importing",
  "storage::out-stock::add_fullfillment_num": "shipment number",
  "storage::out-stock::add_in_bill": "Receipts",
  "storage::out-stock::add_in_type": "Adding storage type",
  "storage::out-stock::add_input": "Please enter content",
  "storage::out-stock::add_order": "Order form",
  "storage::out-stock::add_out_count": "The number of library",
  "storage::out-stock::add_out_date": "Outbound Date",
  "storage::out-stock::add_out_type": "Add a library type",
  "storage::out-stock::add_prod_name": "product name",
  "storage::out-stock::add_purchase_bill": "Purchase Order",
  "storage::out-stock::add_relate_num": "Relevance No.",
  "storage::out-stock::add_remark": "Remark",
  "storage::out-stock::add_save": "save",
  "storage::out-stock::add_save_audit": "Save and review",
  "storage::out-stock::add_select": "please choose",
  "storage::out-stock::add_select_all": "Select All",
  "storage::out-stock::add_sku_add": "Add SKU",
  "storage::out-stock::add_stock": "New Deliveries",
  "storage::out-stock::add_stock_supllier": "supplier",
  "storage::out-stock::add_stock_type": "A library type",
  "storage::out-stock::add_supplier_select_tip": "Please select suppliers",
  "storage::out-stock::add_third_num": "No third-party single",
  "storage::out-stock::add_total_amount": "The total amount (¥)",
  "storage::out-stock::add_upload_click": "Click Upload",
  "storage::out-stock::add_upload_drag": "Drag a file here, or",
  "storage::out-stock::add_upload_template": "Please use the Import Template",
  "storage::out-stock::aduit_time": "Review time",
  "storage::out-stock::audited": "Audited",
  "storage::out-stock::auditor": "Reviewer",
  "storage::out-stock::auditor_select": "Please select reviewer",
  "storage::out-stock::bill": "Deliveries",
  "storage::out-stock::bill_number": "Single number",
  "storage::out-stock::bill_number_input": "Please enter a single number",
  "storage::out-stock::close_out_bill": "Close Deliveries",
  "storage::out-stock::close_reason": "Closed Reason",
  "storage::out-stock::closed": "closed",
  "storage::out-stock::create_time": "Created",
  "storage::out-stock::creator": "founder",
  "storage::out-stock::creator_select": "Please choose Created",
  "storage::out-stock::delete": "delete",
  "storage::out-stock::detail_audit_decrease": "Stock will increase or decrease after review! !",
  "storage::out-stock::detail_audit_decrease_tip": "To perform audits to confirm the operation?",
  "storage::out-stock::detail_audit_time": "Review time",
  "storage::out-stock::detail_auditor": "Reviewer",
  "storage::out-stock::detail_creae_time": "Created",
  "storage::out-stock::detail_creator": "founder",
  "storage::out-stock::detail_out_count": "The number of library",
  "storage::out-stock::detail_out_num": "The number of library",
  "storage::out-stock::detail_out_type": "A library type",
  "storage::out-stock::detail_prod_name": "product name",
  "storage::out-stock::detail_table_bill_num": "Single number",
  "storage::out-stock::detail_table_prod_name": "product name",
  "storage::out-stock::detail_table_sku": "SKU",
  "storage::out-stock::end_time": "End Time",
  "storage::out-stock::export": "Export",
  "storage::out-stock::input_holder": "please enter",
  "storage::out-stock::input_name": "Please enter a name",
  "storage::out-stock::move": "mobile",
  "storage::out-stock::no_audit": "Not reviewed",
  "storage::out-stock::out_bill_num": "Number Delivery",
  "storage::out-stock::out_detail": "Library Details",
  "storage::out-stock::out_type": "A library type",
  "storage::out-stock::out_type_select": "Please select the type of library",
  "storage::out-stock::save": "save",
  "storage::out-stock::sku_select": "Please continue operating after adding SKU",
  "storage::out-stock::start_time": "Starting time",
  "storage::out-stock::status": "status",
  "storage::out-stock::supplier": "supplier",
  "storage::out-stock::supplier_select": "Please select suppliers continue to operate",
  "storage::out-stock::supplier_select_holder": "Please select suppliers",
  "storage::out-stock::table_audit_time": "Review time",
  "storage::out-stock::table_auditor": "Reviewer",
  "storage::out-stock::table_bill_number": "Single number",
  "storage::out-stock::table_btn_audit": "Check",
  "storage::out-stock::table_business_type": "business type",
  "storage::out-stock::table_close": "shut down",
  "storage::out-stock::table_create_time": "Created",
  "storage::out-stock::table_creator": "founder",
  "storage::out-stock::table_detail": "Detail",
  "storage::out-stock::table_edit": "edit",
  "storage::out-stock::table_opt": "operating",
  "storage::out-stock::table_out_time": "Outbound Date",
  "storage::out-stock::table_relate_bill_number": "Relevance No.",
  "storage::out-stock::table_status": "status",
  "storage::out-stock::table_supplier": "supplier",
  "storage::out-stock::请添加SKU": "Please add SKU",
  "storage::out-stock::请输入数量": "Please enter a quantity",
  "storage::out-stock::请输入正确数量": "Please enter the correct number",
  "storage::out-stock::请选择出库日期": "Please select the library date",
  "storage::out-stock::退货数量不能大于可用数量": "Returned quantity not greater than the number of available",
  "stores::order::address": "address",
  "stores::order::address1": "Address 1",
  "stores::order::address2": "Address 2",
  "stores::order::after_cancel": "Sale canceled",
  "stores::order::after_complete": "Sale has been completed",
  "stores::order::after_error": "Abnormal sale",
  "stores::order::after_none": "No sale",
  "stores::order::after_ongoing": "Sale process",
  "stores::order::all": "All Orders",
  "stores::order::all_fee": "Estimated total cost",
  "stores::order::all_sign": "Have been received",
  "stores::order::all_time": "Estimated Aging",
  "stores::order::belong_platform": "Owned platform",
  "stores::order::belong_store": "Their stores",
  "stores::order::billing_info": "Billing Information",
  "stores::order::bind_fulfilment": "Binding logistics providers",
  "stores::order::cancel": "Cancelled",
  "stores::order::cancel_order": "cancel order",
  "stores::order::cancel_success": "Cancel success",
  "stores::order::cant_Identify": "Not recognize",
  "stores::order::city": "city",
  "stores::order::complete": "completed",
  "stores::order::confirm_delivery": "Confirm delivery",
  "stores::order::copy_order": "Copy Order Number",
  "stores::order::country": "country / region",
  "stores::order::create_time": "Created",
  "stores::order::customer": "client",
  "stores::order::customer_info": "Customer Information",
  "stores::order::customer_name": "Customer Name",
  "stores::order::deliver": "Ship",
  "stores::order::deliver_destination": "Shipping destination",
  "stores::order::deliver_fee_plan": "Freight scheme",
  "stores::order::deliver_plan": "Freight scheme",
  "stores::order::deliver_solutions": "Intelligent logistics solutions recommended",
  "stores::order::deliver_success": "Successful delivery",
  "stores::order::deliver_time": "Logistics and delivery time",
  "stores::order::detail": "Detail",
  "stores::order::discount": "Preferential",
  "stores::order::domain": "domain name",
  "stores::order::edit": "edit",
  "stores::order::edit_address": "Edit shipping address",
  "stores::order::edit_fulfilment_success": "Modify the logistics business success",
  "stores::order::email": "mailbox",
  "stores::order::empty_button": "Binding shop",
  "stores::order::empty_text": "All your orders can shop the site for unified management through here",
  "stores::order::empty_title": "Manage your orders",
  "stores::order::end_date": "End Date",
  "stores::order::error": "Abnormal orders",
  "stores::order::export": "Export",
  "stores::order::freight": "Freight",
  "stores::order::fulfilment_goods": "[] Total {goodsNum} member",
  "stores::order::fulfilment_number": "shipment number",
  "stores::order::fulfilment_status": "Logistics state",
  "stores::order::fulfilment_type": "Logistics Type",
  "stores::order::fulfilments": "Logistics providers",
  "stores::order::goods": "commodity",
  "stores::order::goods_name": "product name",
  "stores::order::goods_total": "Total",
  "stores::order::had_select_goods": "Parcel goods",
  "stores::order::input_customer_name": "Enter a customer name search",
  "stores::order::input_domain": "Enter a name for finding XXX.com",
  "stores::order::input_fulfilment_number": "Please enter the logistics a single number lookup",
  "stores::order::input_goods_name": "Please Enter a product name Find",
  "stores::order::input_order_number": "Please enter the order number to find",
  "stores::order::input_pay_number": "Please enter the serial number lookup pay",
  "stores::order::input_promo_code": "Please enter coupon code lookup",
  "stores::order::input_sku": "Please enter the SKU coding to find",
  "stores::order::input_spu": "Please enter the SPU coding",
  "stores::order::item": "Item",
  "stores::order::mark": "Marked Tuotou",
  "stores::order::mark_success": "Tuotou success",
  "stores::order::mask_to_place": "Marking a Tuotou",
  "stores::order::max_price": "The maximum amount",
  "stores::order::message_cancel": "Cancel the order?",
  "stores::order::message_cancel_tips": "After canceling the order will be void and can not be restored",
  "stores::order::message_deliver": "In the sale of goods, can not be shipped",
  "stores::order::message_fulfilment": "Please select the logistics business",
  "stores::order::min_price": "The minimum amount",
  "stores::order::not_deliver_tips": "Unfilled orders, no logistics information",
  "stores::order::not_fulfilment": "Oh .. you're not bind logistics providers, can not be recommended for your transport program",
  "stores::order::not_online_not_sign": "No Internet No sign",
  "stores::order::ongoing": "processing",
  "stores::order::online_not_sign": "No sign has been the Internet",
  "stores::order::online_sign": "The Internet has been to sign",
  "stores::order::operate": "operating",
  "stores::order::order_fee": "order amount",
  "stores::order::order_info": "order information",
  "stores::order::order_number": "order number",
  "stores::order::order_time": "order time",
  "stores::order::other_fee": "Other tariff charges",
  "stores::order::other_info": "other information",
  "stores::order::package_info": "Package information",
  "stores::order::pay_all": "Paid",
  "stores::order::pay_fail": "Failure to pay",
  "stores::order::pay_number": "Serial number paid",
  "stores::order::pay_some": "Partial payment",
  "stores::order::pay_status": "Payment status",
  "stores::order::pay_time": "Payment time",
  "stores::order::pay_type": "payment method",
  "stores::order::phone": "phone",
  "stores::order::platform_order": "Order No. Platform",
  "stores::order::prev_step": "Previous",
  "stores::order::price": "Money",
  "stores::order::promo_code": "Promo Code",
  "stores::order::province": "province / State",
  "stores::order::receiver": "Receiver",
  "stores::order::receiving_info": "delivery information",
  "stores::order::recommend": "recommend",
  "stores::order::refund_all": "refunded",
  "stores::order::refund_fail": "Refund failed",
  "stores::order::refund_some": "Partial refund",
  "stores::order::refund_wait": "Be refunded",
  "stores::order::risk_order": "Orders risk",
  "stores::order::rule_address1": "Please enter the address 1",
  "stores::order::rule_city": "Please enter a city",
  "stores::order::rule_country": "Please enter a country / region",
  "stores::order::rule_email": "please input your email",
  "stores::order::rule_first_name": "Enter firstName",
  "stores::order::rule_last_name": "Enter lastName",
  "stores::order::rule_phone": "Phone number format is incorrect",
  "stores::order::rule_phone_empty": "Please enter phone number",
  "stores::order::rule_right_email": "Please enter a valid email",
  "stores::order::rule_zip": "Please enter a zip code",
  "stores::order::sales_status": "Aftermarket state",
  "stores::order::same_address": "The same as shipping address",
  "stores::order::select_all": "select all",
  "stores::order::select_date": "Select Date",
  "stores::order::select_fulfilment": "Please select the successful delivery of logistics alone",
  "stores::order::select_fulfilment_nomber": "Please select a single logistics",
  "stores::order::select_goods": "Please select the parcel goods",
  "stores::order::select_goods_total": "Co [{x}] items, the total weight",
  "stores::order::ship_goods_img": "product picture",
  "stores::order::ship_input_fulfilment": "Please enter the logistics a single number",
  "stores::order::ship_inside": "The current logistics provider does not support domestic transportation, not recommended for you",
  "stores::order::ship_quantity": "Quantity",
  "stores::order::ship_select_deliver_time": "Please select logistics delivery time",
  "stores::order::ship_select_fulfilment": "Please select the type of Logistics",
  "stores::order::shipping": "Shipped",
  "stores::order::shipping_fee": "Freight basis",
  "stores::order::shipping_info": "Logistics Information",
  "stores::order::shipping_time": "Delivery time",
  "stores::order::shipping_way": "Mode of transport",
  "stores::order::show_more": "Expand More",
  "stores::order::some_deliver": "Section delivery",
  "stores::order::some_sign": "Section sign",
  "stores::order::start_date": "start date",
  "stores::order::status": "status",
  "stores::order::store": "Shop",
  "stores::order::store_order": "Shop Order Number",
  "stores::order::to_after_sales": "Initiated sale",
  "stores::order::to_deliver": "To deliver",
  "stores::order::utmSource": "Channel Source",
  "stores::order::wait": "to be delivered",
  "stores::order::wait_pay": "To be paid",
  "stores::order::weigth_zero": "0 total weight of goods, logistics solutions can not be recommended for you",
  "stores::order::yuntu": "Cloud transit Logistics",
  "stores::order::zip": "Zip code",
  "stores::products-info::add": "New Product",
  "stores::products-info::add_sku": "New SKU",
  "stores::products-info::add_supplier": "New Suppliers",
  "stores::products-info::address": "Province City District",
  "stores::products-info::base_attr": "The basic properties",
  "stores::products-info::base_info": "basic information",
  "stores::products-info::batch_edit": "Batch Edit",
  "stores::products-info::batch_had_release": "Batch release",
  "stores::products-info::batch_operate": "Batch operations",
  "stores::products-info::batch_tag": "Batch marking",
  "stores::products-info::batch_tags": "Batch tagging",
  "stores::products-info::category": "Product categories",
  "stores::products-info::choose_file": "Selected Files",
  "stores::products-info::compare_at_price": "Price",
  "stores::products-info::copy": "copy",
  "stores::products-info::creatr_time": "Created",
  "stores::products-info::currency": "Settlement Currency",
  "stores::products-info::detail": "Detail",
  "stores::products-info::detail_address": "Address",
  "stores::products-info::dialog_copy_tips": "Copy Product name would be: [{title}] (copy)",
  "stores::products-info::dialog_copy_title": "Confirm that you want to copy this product?",
  "stores::products-info::dialog_manager_attr": "Property management",
  "stores::products-info::dialog_put_down_tips": "After the shelf all the shops will stop selling the SPU!",
  "stores::products-info::dialog_put_down_title": "To confirm that the merchandise off the shelf?",
  "stores::products-info::dialog_put_on_tips": "After shelves can release the goods to the shop",
  "stores::products-info::dialog_put_on_title": "To confirm that the merchandise shelves?",
  "stores::products-info::dialog_release_again_tips": "After release the commodity information to synchronize {{name}} station",
  "stores::products-info::dialog_release_again_title": "Determine the need to re-release it?",
  "stores::products-info::dialog_release_tips": "After the release can sell management",
  "stores::products-info::dialog_release_title": "Confirm that you want to publish the goods?",
  "stores::products-info::dialog_start_sale_tips": "The site will not open sale of goods shop [selling] {name}",
  "stores::products-info::dialog_start_sale_title": "Determining the sale it?",
  "stores::products-info::dialog_stop_sale_tips": "After the sale of goods will not be the site shop [selling] {name}",
  "stores::products-info::dialog_stop_sale_title": "Determining the sale it?",
  "stores::products-info::edit": "edit",
  "stores::products-info::edit_sku": "Edit SKU",
  "stores::products-info::edit_supplier": "Set Suppliers",
  "stores::products-info::email": "E-mail",
  "stores::products-info::empty_add_goods": "New Product",
  "stores::products-info::empty_bind_store": "Binding shop",
  "stores::products-info::empty_goods": "Manage your product",
  "stores::products-info::empty_goods_tips": "Store all of your sites can be unified management of goods through here",
  "stores::products-info::end_time": "End Time",
  "stores::products-info::export": "Export",
  "stores::products-info::fail_number": "The number of failures",
  "stores::products-info::first_stock": "Beginning stocks of goods",
  "stores::products-info::goods_cate": "Product categories",
  "stores::products-info::goods_chart": "Product Size Table",
  "stores::products-info::goods_detail": "product details",
  "stores::products-info::goods_info": "Product information",
  "stores::products-info::goods_sku": "Product SKU",
  "stores::products-info::goods_spu": "Commodity SPU",
  "stores::products-info::goods_stock": "Commodity stocks",
  "stores::products-info::goods_tag": "Goods Tag",
  "stores::products-info::had_complete": "completed",
  "stores::products-info::had_release": "Published",
  "stores::products-info::import": "Importing",
  "stores::products-info::import_btn": "Click Upload",
  "stores::products-info::import_example": "Please use the Import templates",
  "stores::products-info::import_example_btn": "click to download",
  "stores::products-info::import_fail_log": "Export failed log",
  "stores::products-info::import_goods": "Import of goods",
  "stores::products-info::import_log": "Import log",
  "stores::products-info::import_number": "Import Quantity",
  "stores::products-info::import_time": "Import time",
  "stores::products-info::import_tips": "The drag and drop files here or",
  "stores::products-info::include_deliver_fee": "Including logistics costs",
  "stores::products-info::input_at_price": "Please enter the original price",
  "stores::products-info::input_attr": "Please enter the property",
  "stores::products-info::input_category": "Please enter a product category",
  "stores::products-info::input_currency": "Please select your billing currency",
  "stores::products-info::input_detail_address": "Please enter the full address",
  "stores::products-info::input_email": "Enter e-mail",
  "stores::products-info::input_first_stock": "Please enter the article beginning stocks",
  "stores::products-info::input_goods_chart": "Enter Product Size",
  "stores::products-info::input_goods_detail": "Please enter Product Details",
  "stores::products-info::input_goods_name": "Please Enter a product name",
  "stores::products-info::input_person": "Please enter the contact",
  "stores::products-info::input_phone": "Please type your phone number",
  "stores::products-info::input_purchase_price": "Enter cost price",
  "stores::products-info::input_safe_stock": "Please enter the security stock",
  "stores::products-info::input_sale_price": "Please enter the price",
  "stores::products-info::input_sku": "Please enter the platform SKU Find",
  "stores::products-info::input_spu": "Please enter the platform to find SPU",
  "stores::products-info::input_supplier": "Please enter the supplier name lookup",
  "stores::products-info::input_supplier_name": "Enter the name of the supplier",
  "stores::products-info::input_weight": "Please enter the weight",
  "stores::products-info::is_sale": "in stock",
  "stores::products-info::list": "Product List",
  "stores::products-info::message_choose_file": "Please select the file",
  "stores::products-info::message_choose_tag": "Please select tag",
  "stores::products-info::message_down_fail": "Shelves failure",
  "stores::products-info::message_goods_text": "A commodity",
  "stores::products-info::message_had_down": "Off the shelf",
  "stores::products-info::message_had_on": "It has been added to",
  "stores::products-info::message_input_number": "Please key in numbers",
  "stores::products-info::message_input_sku": "Please complete sku property values",
  "stores::products-info::message_not_same": "New attribute values can not be repeated",
  "stores::products-info::message_on_fail": "Added fail",
  "stores::products-info::message_one_sku": "No attribute allows only add a SKU",
  "stores::products-info::message_start_sale": "Already on sale",
  "stores::products-info::message_stop_fail": "failure",
  "stores::products-info::message_stop_sale": "Discontinued",
  "stores::products-info::message_store_text": "A shop",
  "stores::products-info::message_three_attr": "Only add up to 3 property",
  "stores::products-info::more": "More",
  "stores::products-info::name": "product name",
  "stores::products-info::no": "no",
  "stores::products-info::none_data": "No data",
  "stores::products-info::not_pricing": "No pricing",
  "stores::products-info::not_release": "Unpublished",
  "stores::products-info::ongoing": "processing",
  "stores::products-info::operate": "operating",
  "stores::products-info::origin_price_shipping": "Price (free shipping)",
  "stores::products-info::person": "Contact",
  "stores::products-info::phone": "contact number",
  "stores::products-info::photos": "Photo wall",
  "stores::products-info::price": "Pricing",
  "stores::products-info::pricing": "Pricing",
  "stores::products-info::purchase_price": "Cost price",
  "stores::products-info::put_down": "Shelves",
  "stores::products-info::put_on": "Shelves",
  "stores::products-info::release": "release",
  "stores::products-info::release_again": "Determine the need to re-release it?",
  "stores::products-info::release_fail": "Publish failed",
  "stores::products-info::release_ing": "announcing",
  "stores::products-info::release_status": "Post status",
  "stores::products-info::release_to_release": "After release the commodity information to synchronize {name} station",
  "stores::products-info::release_wait": "To be released",
  "stores::products-info::return": "return",
  "stores::products-info::safe_stock": "Safety stock",
  "stores::products-info::sale_manager": "Vendor Management",
  "stores::products-info::sale_price": "Selling price",
  "stores::products-info::sale_price_shipping": "Price (free shipping)",
  "stores::products-info::sale_status": "Status Sale",
  "stores::products-info::save": "save",
  "stores::products-info::select_category": "Please select the product category",
  "stores::products-info::select_num": "Selected items] [{x} |",
  "stores::products-info::select_photos": "Choose Picture",
  "stores::products-info::select_spu_price": "Please select a priced SPU",
  "stores::products-info::select_store": "Please select a store",
  "stores::products-info::select_supplier": "Please select suppliers",
  "stores::products-info::select_tag": "Please select the product label",
  "stores::products-info::sku": "Platform SKU",
  "stores::products-info::spu": "SPU platform",
  "stores::products-info::spu_price": "SPU has Pricing",
  "stores::products-info::start_time": "Starting time",
  "stores::products-info::status": "status",
  "stores::products-info::stock": "in stock",
  "stores::products-info::stop_sale": "Stock",
  "stores::products-info::stop_sale_tips": "Determining the sale it?",
  "stores::products-info::stop_sale_to": "After the sale of goods will not be the site shop selling {name}",
  "stores::products-info::store": "Shop",
  "stores::products-info::store_spu": "Shop SPU",
  "stores::products-info::success_number": "Number of successful",
  "stores::products-info::supplier": "supplier",
  "stores::products-info::supplier_name": "Supplier name",
  "stores::products-info::supply_cost": "Delivery costs",
  "stores::products-info::use_stock": "Available inventory",
  "stores::products-info::weight": "weight",
  "stores::products-info::yes": "Yes",
  "stores::products-info::attr_info": "Attribute information",
  "stores::store::add_bind_confirn": "Ok",
  "stores::store::add_bind_shop": "We have received your application, so stay tuned",
  "stores::store::add_time": "Joined",
  "stores::store::address": "address",
  "stores::store::api_password": "Api password",
  "stores::store::apply_open": "Open Application",
  "stores::store::auth": "Authorized shops",
  "stores::store::authentication": "Certification Information",
  "stores::store::authentication_info": "Authentication information is an important proof for you to authorize store data and subscribe to store changes, and to conduct unified management of the station group. Please make sure that it is correct! The Api Key and its password are used to authorize the synchronization of store data, and the webhook is used to subscribe to store changes;",
  "stores::store::base_detail": "Basic Information",
  "stores::store::bind_benefit": "After binding one-stop shop to manage all of your store site",
  "stores::store::bind_info": "The default authorization Shoplus shop to shop founder's account, if you are the shop staff, please contact the store to create a person authorized shop",
  "stores::store::bind_now": "Binding immediately",
  "stores::store::bind_shop": "Binding shop",
  "stores::store::business": "Business sectors",
  "stores::store::category": "Business category",
  "stores::store::choose_auth": "Please select a user needs to authorize the shop",
  "stores::store::choose_user": "Choose a user",
  "stores::store::city": "city",
  "stores::store::country": "country",
  "stores::store::create_time": "Created",
  "stores::store::currency": "currency",
  "stores::store::customer": "customer",
  "stores::store::detail": "Detail",
  "stores::store::edit": "edit",
  "stores::store::edit_shop": "Editing shop",
  "stores::store::end_time": "End Time",
  "stores::store::fail": "failure",
  "stores::store::goods": "commodity",
  "stores::store::goods_manager": "Commodity Management",
  "stores::store::goods::category": "Product categories",
  "stores::store::goods::compare_at_price": "Price",
  "stores::store::goods::detail": "product details",
  "stores::store::goods::export": "Export",
  "stores::store::goods::goods_status": "Product Status",
  "stores::store::goods::goods_stock": "Commodity stocks",
  "stores::store::goods::input_end_time": "End Time",
  "stores::store::goods::input_start_time": "Starting time",
  "stores::store::goods::is_sale": "Sale",
  "stores::store::goods::name": "product name",
  "stores::store::goods::not_price": "No pricing",
  "stores::store::goods::now": "Current shop",
  "stores::store::goods::platform_sku": "Platform SKU",
  "stores::store::goods::platform_spu": "SPU platform",
  "stores::store::goods::purchase_price": "Cost price",
  "stores::store::goods::put_off": "Shelves",
  "stores::store::goods::put_on": "Shelves",
  "stores::store::goods::release": "release",
  "stores::store::goods::release_again_tips": "Will release the product information synchronized to the shop",
  "stores::store::goods::release_again_title": "Determine the need to re-release it?",
  "stores::store::goods::release_fail": "Publish failed",
  "stores::store::goods::release_had": "Published",
  "stores::store::goods::release_ing": "announcing",
  "stores::store::goods::release_status": "Post status",
  "stores::store::goods::release_tips": "After the release can sell management",
  "stores::store::goods::release_title": "Confirm that you want to publish the goods?",
  "stores::store::goods::release_wait": "To be released",
  "stores::store::goods::safe_stock": "Safety stock",
  "stores::store::goods::sale_price": "Selling price",
  "stores::store::goods::sale_status": "Status Sale",
  "stores::store::goods::select_category": "Please select the product category",
  "stores::store::goods::select_supplier": "Please select suppliers",
  "stores::store::goods::spu": "Commodity SPU",
  "stores::store::goods::start_sale_fail": "Sale failed",
  "stores::store::goods::start_sale_success": "Sale success",
  "stores::store::goods::start_sale_tips": "Open sale of goods will be sold in the shop",
  "stores::store::goods::start_sale_title": "Determining the sale it?",
  "stores::store::goods::stop_sale": "Stock",
  "stores::store::goods::stop_sale_fail": "Sale failed",
  "stores::store::goods::stop_sale_success": "Sale success",
  "stores::store::goods::stop_sale_tips": "After the sale of goods will not be sold in this shop",
  "stores::store::goods::stop_sale_title": "Determining the sale it?",
  "stores::store::goods::use_stock": "Available inventory",
  "stores::store::guide": "Authorization guidelines",
  "stores::store::holder::api_secret": "Please enter the API Secret",
  "stores::store::holder::api_token": "Please enter API Token",
  "stores::store::holder::api_uid": "Please enter the API UID",
  "stores::store::holder::shopify_api_key": "Shopify store secret key from the API Key",
  "stores::store::holder::shopify_api_password": "Shopify store API password",
  "stores::store::holder::shopify_webhook": "Shopify store Webhook key",
  "stores::store::holder::shopline_token": "Please enter Shopline Token",
  "stores::store::holder::shoplus_api_key": "Shoplus key shop keys API Key",
  "stores::store::holder::shoplus_api_password": "Shoplus shop API password",
  "stores::store::how_bind": "How to bind Shoplus shop",
  "stores::store::ind_domail": "Independent domain",
  "stores::store::message_edit_success": "Edited successfully",
  "stores::store::message_edit_success_webhook": "Edited successfully, is to synchronize your data and subscribe webhook",
  "stores::store::message_success": "Authorized shop success",
  "stores::store::message_success_webhook": "Authorized shop success, is to synchronize your data and subscribe webhook",
  "stores::store::more": "More",
  "stores::store::no_sync": "Not synchronized",
  "stores::store::none_shop": "You are not binding shop",
  "stores::store::open_close": "Shop enabled, the system will synchronize your data; if it is inactive and will not synchronize data;",
  "stores::store::operate": "operating",
  "stores::store::order": "Order form",
  "stores::store::other_platform": "Other platforms",
  "stores::store::other_platform_tips": "Please select the binding platform, a number of platforms has yet to open, click on the ’openapplication‘ to tell us it ~",
  "stores::store::phone": "contact details",
  "stores::store::platform": "Owned platform",
  "stores::store::platform::shop_name": "Platform Store name",
  "stores::store::prev_step": "Previous",
  "stores::store::province": "province",
  "stores::store::recommend": "recommend",
  "stores::store::recommend_paltform": "Recommended platform",
  "stores::store::retry": "Click Retry",
  "stores::store::rule_domain": "Please enter the domain name shop",
  "stores::store::rule_empty": "Please enter content",
  "stores::store::rule_error": "wrong format",
  "stores::store::rule_input_name": "Enter the store name",
  "stores::store::rule_input_platform": "Please enter your platform",
  "stores::store::rule_input_something": "Please enter content",
  "stores::store::rule_select_category": "Select business category",
  "stores::store::rule_select_status": "Please select a store state",
  "stores::store::rule_shop_name": "Store name not exceed 20 characters or contain spaces",
  "stores::store::rule_space": "No spaces",
  "stores::store::save_sync": "Save and sync",
  "stores::store::shop_close": "Disable",
  "stores::store::shop_detail": "Store details",
  "stores::store::shop_domail": "Shops domain",
  "stores::store::shop_guide": "{mallType} authorized shop guidance",
  "stores::store::shop_info": "Store Information",
  "stores::store::shop_name": "Store Name",
  "stores::store::shop_open": "Enable",
  "stores::store::shop_status": "Shop status",
  "stores::store::shopify_four": "Once created, the application API key and other information to fill in the right window;",
  "stores::store::shopify_one": "Log in to your account shopify",
  "stores::store::shopify_one_text": "Link: https: //accounts.shopify.com/store-login",
  "stores::store::shopify_three": "Click to create a new proprietary applications, all permissions are set to ’readandwrite‘",
  "stores::store::shopify_two": "Click the menu [application] to enter the [Management] proprietary applications",
  "stores::store::shopify_three_2": "If you enter this page for the first time, please check the following three check boxes, and click to open private application; if you've already set this page, please see the fourth step;",
  "stores::store::shopline_one": "Log in to your account shopline",
  "stores::store::shopline_one_text": "Link: https: //admin.myshopline.cn",
  "stores::store::shopline_three": "After entering, pulled the bottom of the page to get Shopline Token, and Token copy paste to the right of the input box",
  "stores::store::shopline_two": "Click on the menu [Settings], enter [Settings] foundation",
  "stores::store::shoplus_bind": "Creating shoplus shop immediately",
  "stores::store::shoplus_tips": "To bind the other shoplus, please contact the store administrator authorized shop",
  "stores::store::shoplus_title": "Shoplus shop supports automatic binding, easy to manage independent station",
  "stores::store::shopplazza_four": "The application API key and other information to fill in the right window;",
  "stores::store::shopplazza_one": "Log in to your shoplazza",
  "stores::store::shopplazza_one_text": "Accounts link: https: //accounts.shoplazza.com/login",
  "stores::store::shopplazza_three": "Create a new proprietary application, all permissions will be set to ’readandwrite‘",
  "stores::store::shopplazza_two": "Click the application menu [market], enter [Private App]",
  "stores::store::status": "status",
  "stores::store::success": "success",
  "stores::store::sync": "Synchronize",
  "stores::store::sync_again": "Whether to synchronize the data store again?",
  "stores::store::sync_data_now": "Store data synchronization!",
  "stores::store::sync_data_success": "Store data synchronization success",
  "stores::store::sync_end": "End synchronization",
  "stores::store::sync_fail": "Synchronization failed",
  "stores::store::sync_result": "Sync Results",
  "stores::store::sync_success": "Successful synchronization",
  "stores::store::sync_time": "synchronised time",
  "stores::store::sync_tips": "Synchronization Tips",
  "stores::store::syncing": "synchronizing",
  "stores::store::task_cancel": "Task canceled",
  "stores::store::task_end": "End Task",
  "stores::store::transfer_platform": "Migration Platform",
  "stores::store::transfer_result": "Migration results",
  "stores::store::wait": "Please wait",
  "stores::store::webhook_fail": "Subscribe webhook failed, please re-subscribe",
  "stores::store::webhook_subscribe_success": "Subscribe successful",
  "stores::store::webhook_tips": "prompt",
  "stores::store::webhook_tips_desc": "Please make sure to fill in the correct store webhook secret",
  "stores::store::zip": "Zip Code",
  "STRING_TO_NUMBER_FAIL": "String to Digital fail",
  "SUPPLIER_NOT_FOUND": "供应商(Id:%s)不存在",
  "supplier::add_button": "New Suppliers",
  "supplier::edit_button": "Edit suppliers",
  "supplier::form_address": "Address",
  "supplier::form_area": "area",
  "supplier::form_email": "E-mail",
  "supplier::input_phone_num": "Please enter phone number",
  "supplier::name": "Supplier name",
  "supplier::placeholder_address": "Please enter the full address",
  "supplier::placeholder_email": "Enter e-mail",
  "supplier::placeholder_email_wrong": "E-mail format is incorrect",
  "supplier::placeholder_name": "Search by content",
  "supplier::placeholder_phone": "Please type your phone number",
  "supplier::placeholder_reSupplier": "Vendor Name Repeat",
  "supplier::placeholder_staff": "Please enter the contact",
  "supplier::placeholder_supplier": "Enter the name of the supplier",
  "supplier::status": "status",
  "supplier::status_all": "Complete",
  "supplier::status_off": "Disable",
  "supplier::status_on": "Enable",
  "supplier::table_createTime": "Created",
  "supplier::table_detail": "Detail",
  "supplier::table_edit": "edit",
  "supplier::table_handle": "operating",
  "supplier::table_name": "Supplier name",
  "supplier::table_no": "supplier code",
  "supplier::table_phone": "contact number",
  "supplier::table_staff": "Contact",
  "supplier::table_status": "status",
  "supplier::turn_off::tip": "After deactivation no choice of supplier",
  "supplier::turn_off::title": "We need to deactivate determine supplier",
  "supplier::wrong": "Server problems, please try again later",
  "SYSTEM_AUTH_GRANT": "Account already exists, go to login",
  "SYSTEM_AUTH_PENDING": "Audit system privileges, please be patient",
  "system::aftermarket::source::客服部门": "Customer Services",
  "system::aftermarket::source::消费者": "consumer",
  "system::aftermarket::type::已发货仅退款": "Shipped only refund",
  "system::aftermarket::type::未发货退款": "No shipping refunds",
  "system::aftermarket::type::补偿退款": "Compensation Refund",
  "system::common::404": "Page lost to the siege lion in search of emergency ...",
  "system::common::btn::auth_shop": "Authorized shops",
  "system::common::btn::back": "return",
  "system::common::btn::cancel": "cancel",
  "system::common::btn::change_language": "Switch language system",
  "system::common::btn::change_system_language": "Language switching system",
  "system::common::btn::close": "shut down",
  "system::common::btn::confirm": "determine",
  "system::common::btn::doc": "Operation Manual",
  "system::common::btn::example": "View Sample",
  "system::common::btn::logout": "sign out",
  "system::common::btn::no_data": "No data",
  "system::common::btn::refresh": "Refresh",
  "system::common::btn::reset": "Reset",
  "system::common::btn::save": "save",
  "system::common::btn::save_as": "Save as",
  "system::common::btn::search": "search for",
  "system::common::btn::select_change_language_holder": "Select System Language",
  "system::common::chinese": "Chinese",
  "system::common::clear_all": "Clear",
  "system::common::dialog::change_merchant_tooltip": "prompt",
  "system::common::dialog::change_merchant_tooltip_message": "Are you sure to switch to the {} {userName}?",
  "system::common::dialog::message_manage": "Message Center",
  "system::common::dialog::message_more": "see more",
  "system::common::end_date": "start date",
  "system::common::english": "English",
  "system::common::input_holder": "please enter",
  "system::common::input_search": "Inquire",
  "system::common::NO": "No.",
  "system::common::no_authority": "No you access, please contact the administrator",
  "system::common::no_authority_tooltip": "You authorize any stores yet",
  "system::common::select_all": "Complete",
  "system::common::select_placeholder": "please choose",
  "system::common::start_date": "End Date",
  "system::email_type::imap": "imap",
  "system::email_type::smtp": "smtp",
  "system::email::category::分类1": "Category 1",
  "system::email::category::分类2": "Category 2",
  "system::error::serve": "Service error, please try again later",
  "system::error::upload_custom_img_tip": "Picture upload failed, please try again later or contact your administrator.",
  "system::error::upload_tip": "Upload failed, please try again later ~",
  "system::exchange-manager::cancel": "cancel",
  "system::exchange-manager::change_confirm": "Confirm the changes",
  "system::exchange-manager::confirm": "determine",
  "system::exchange-manager::confitm_title": "prompt",
  "system::exchange-manager::confitm_title_tips": "Determined to modify the current exchange rate it?",
  "system::exchange-manager::dollar": "US dollar",
  "system::exchange-manager::exchange_input": "Please enter exchange rate value",
  "system::exchange-manager::rmb": "Renminbi",
  "system::exchange-manager::setting": "Exchange rate set",
  "system::exchange-manager::title": "The exchange rate will be used to automatically convert the cost of goods, the cost of the statistical reports, there is the impact profits",
  "system::fulfilmentstatus::已上网": "Have Internet",
  "system::fulfilmentstatus::已发货": "Shipped",
  "system::fulfilmentstatus::已签收": "Have been received",
  "system::fulfilmentstatus::待发货": "to be delivered",
  "system::fulfilmentstatus::待处理": "Pending",
  "system::fulfilmentstatus::退货中": "In return",
  "system::fulfilmentstatus::部分发货": "Section delivery",
  "system::fulfilmentstatus::部分签收": "Section sign",
  "system::function::delete": "delete",
  "system::function::download": "download",
  "system::function::edit": "edit",
  "system::inStock::type::其他入库": "Other storage",
  "system::inStock::type::备货入库": "Stocking warehouse",
  "system::inStock::type::期初入库": "Beginning storage",
  "system::inStock::type::采购入库": "Procurement of storage",
  "system::order_status::售后中": "Sale in",
  "system::order_status::已取消": "Cancelled",
  "system::order_status::已妥投": "It has Tuotou",
  "system::order_status::已完成": "completed",
  "system::order_status::待支付": "To be paid",
  "system::order_status::待签收": "Sign to be",
  "system::order_status::进行中": "processing",
  "system::order_status::部分发货": "Section delivery",
  "system::outStock::type::补发出库": "Complement issued library",
  "system::outStock::type::销售出库": "Sales Delivery",
  "system::pay_status::已取消": "Cancelled",
  "system::pay_status::已支付": "Paid",
  "system::pay_status::已退款": "refunded",
  "system::pay_status::待支付": "To be paid",
  "system::pay_status::待退款": "Be refunded",
  "system::pay_status::支付失败": "Failure to pay",
  "system::pay_status::退款失败": "Refund failed",
  "system::pay_status::部分退款": "Partial refund",
  "system::pay_type::AsiaBill": "AsiaBill",
  "system::pay_type::bogus": "bogus",
  "system::pay_type::manual": "manual",
  "system::pay_type::OceanPayment": "OceanPayment",
  "system::pay_type::PacyPay": "PacyPay",
  "system::pay_type::PayPal": "PayPal",
  "system::pay_type::PingPongPay": "PingPongPay",
  "system::pay_type::Stripe": "Stripe",
  "system::pay_type::UseePay": "UseePay",
  "system::pay_type::WorldPay": "WorldPay",
  "system::pay_type::其他": "other",
  "system::pay_type::未支付": "unpaid",
  "system::platform::Shopify": "Shopify",
  "system::platform::Shopline": "Shopline",
  "system::platform::Shoplus": "Shoplus",
  "system::platform::店匠": "Carpenter shop",
  "system::protocol::default": "default",
  "system::protocol::ssl": "SSL",
  "system::purchase::status::全部发货": "All shipments",
  "system::purchase::status::已关闭": "closed",
  "system::purchase::status::已复核": "It has been reviewed",
  "system::purchase::status::已完成": "completed",
  "system::purchase::status::已审核": "Audited",
  "system::purchase::status::待审核": "Pending",
  "system::purchase::status::部分发货": "Section delivery",
  "system::rbac": "Authorization Management",
  "system::rbac::add": "Add licenses",
  "system::rbac::add_auth": "Add licenses",
  "system::rbac::auth_block": "Menu function rights",
  "system::rbac::auth_edit": "Edit Authorization",
  "system::rbac::auth_shop_input": "Please enter the authorization store",
  "system::rbac::auth_tips": "prompt",
  "system::rbac::check_info": "Check which represents the user is authorized to view the data in these stores, do not check to see that is not",
  "system::rbac::delete": "delete",
  "system::rbac::edit": "edit",
  "system::rbac::name": "Full name",
  "system::rbac::name_input": "Please type in your name",
  "system::rbac::name_tips": "Name length of less than 12",
  "system::rbac::opt": "operating",
  "system::rbac::phone": "Phone number or email",
  "system::rbac::phone_input": "Please enter phone number",
  "system::rbac::phone_input_error": "Phone number format is incorrect",
  "system::rbac::phone_num": "Phone number or email",
  "system::rbac::phone_tips": "Please enter the phone number or email",
  "system::rbac::search_num": "Search for a name or phone number or email",
  "system::rbac::shop": "Shop",
  "system::rbac::shop_auth": "Authorized shops",
  "system::rbac::user_cancel": "cancel",
  "system::rbac::user_confirm": "determine",
  "system::rbac::user_delete_tips": "Confirm delete the user do?",
  "system::rbac::user_delete_warn": "Once deleted, irrevocable, Proceed with caution",
  "system::rbac::user_name": "username",
  "system::refund::type::主动退款": "Refund initiative",
  "system::refund::type::拒付": "Protest",
  "system::report_option::data_all": "Complete",
  "system::report_option::data_area": "Interval",
  "system::report_option::data_equal": "equal",
  "system::report_option::data_large": "more than the",
  "system::report_option::data_large_equal": "greater or equal to",
  "system::report_option::data_less": "Less than",
  "system::report_option::data_less_equal": "Less than or equal",
  "system::report_option::data_not_equal": "not equal to",
  "system::responsible::供应商": "supplier",
  "system::responsible::平台": "platform",
  "system::responsible::物流商": "Logistics providers",
  "system::sale_status::售后处理中": "Sale process",
  "system::sale_status::售后已取消": "Sale canceled",
  "system::sale_status::售后已完成": "Sale has been completed",
  "system::sale_status::售后异常": "Abnormal sale",
  "system::sale_status::无售后": "No sale",
  "system::status_option::全部状态": "All states",
  "system::status_option::已删除": "deleted",
  "system::status_option::已禁用": "disabled",
  "system::status_option::已结束": "over",
  "system::status_option::待开始": "Began to be",
  "system::status_option::进行中": "processing",
  "system::time::category::data_all": "Complete",
  "system::time::category::data_in": "contain",
  "system::time::category::data_not_in": "Does not contain",
  "system::time::text::data_all": "All time",
  "system::time::text::data_auto": "Custom time period",
  "system::time::text::data_ecentday_notoday": "Over the past N days",
  "system::time::text::data_frontday": "Previous N days (one day)",
  "system::time::text::data_monthDate_today": "Today month",
  "system::time::text::data_monthDate_yestoday": "Month to yesterday",
  "system::time::text::data_recentday": "Recently N days",
  "system::time::text::include": "to",
  "system::time::text::last_month": "last month",
  "system::time::text::latest_30": "Last 30 Days",
  "system::time::text::latest_7": "Last 7 Days",
  "system::time::text::month": "month to date",
  "system::time::text::today": "Nowadays",
  "system::time::text::year": "this year",
  "system::time::text::yestoday": "yesterday",
  "system::tip::active_success": "Activation Successful",
  "system::tip::add_success": "Added successfully",
  "system::tip::audit_success": "Audit Success",
  "system::tip::bind_success": "Successfully bind",
  "system::tip::cancel_success": "Cancel success",
  "system::tip::change_success": "Successfully modified",
  "system::tip::close_success": "Close success",
  "system::tip::control_error": "operation failed",
  "system::tip::control_success": "Successful operation",
  "system::tip::copy_success": "Copied successfully",
  "system::tip::create_success": "New success",
  "system::tip::delete_success": "successfully deleted",
  "system::tip::edit_success": "Edited successfully",
  "system::tip::in_success": "Import success",
  "system::tip::open_success": "Open success",
  "system::tip::pub_success": "Successfully posted",
  "system::tip::reject_success": "Success dismissed",
  "system::tip::save_success": "Saved successfully",
  "system::tip::send_success": "Sent successfully",
  "system::tip::update_success": "update completed",
  "system::tip::upload_attachment": "Upload Attachment",
  "system::tip::upload_click": "Add attachments",
  "system::tip::upload_drag_tip": "Or drag and drop upload",
  "system::tip::upload_limit_tip": "Supports up to {{limit}} attachments beyond {{limit}} suggestion Upload Package support {{accept}}",
  "system::tip::upload_limit_tip_new": "Supports up to [Annex] {limit}, {{limit}] beyond a suggestion Upload Package, support [] {accept}",
  "system::tip::upload_success": "Upload successful",
  "system::trend::CPC": "CPC",
  "system::trend::CPM": "CPM",
  "system::trend::下单量": "The order volume",
  "system::trend::加购率": "Plus purchase rate",
  "system::trend::加购量": "Plus the amount purchased",
  "system::trend::发起结算率": "Initiate settlement rate",
  "system::trend::发起结账量": "Launch checkout amount",
  "system::trend::展示量": "Display amount",
  "system::trend::广告转化率": "Ad conversion rate",
  "system::trend::浏览率": "Reservation",
  "system::trend::点击率": "Click to rate",
  "system::trend::点击量": "Traffic",
  "TAG_NOT_FOUND": "标签（%s）不存在",
  "token_error": "token abnormal",
  "trackingmore_numbers_is_null": "Logistics single query to the data is empty",
  "UNKNOWN_SYSTEM_FAIL": "System spaced-out, please try again later",
  "update_shipping_companyid_fail": "Change logistics providers fail",
  "UPDATE_VOCABULARY_ERROR": "Update business vocabulary synchronization failure",
  "UPDAYE_ERROR": "Words corresponding to the front end of an existing",
  "USER_BINDED_WECHANT": "Mobile phone number has been bound micro letter",
  "USER_DC_DENY_AUTH": "Saas industry insight authority audit failure, please re-launch",
  "USER_DC_GRANT_AUTH": "SaaS industry insight into the account already exists, go to login",
  "USER_DC_PENDING_AUTH": "Saas industry insight authority review, please be patient",
  "USER_DENY_AUTH": "Saas establishment authority audit failure, please re-launch",
  "USER_EXPIRE": "Package has expired! Go to renewal",
  "USER_GRANT_AUTH": "Saas station account already exists, go to login",
  "USER_NOT_AUTH": "No Saas station permissions to initiate the application",
  "USER_NOT_BIND_COMBO": "Account not opened any package",
  "USER_NOT_DC_AUTH": "No saas industry insight permissions to initiate the application",
  "USER_NOT_DIFF": "Enter the password twice inconsistent",
  "USER_NOT_EXIT": "User does not exist",
  "USER_NOT_LEGAL_SIGN": "Signature illegal",
  "USER_NOT_SIGN": "Signature can not be empty",
  "USER_NOTIFICATION_NOT_FOUNT": "User Message does not exist!",
  "USER_OR_PASSWORD_ERROR": "wrong user name or password!",
  "USER_PENDING_AUTH": "Saas establishment rights review, please be patient",
  "USER_TOKEN_EXPIRED": "User token expires",
  "USER_TOKEN_INVALID": "User token failure",
  "USER_TOKEN_UNMATCHED": "Failure user token (mismatched)",
  "user-guidance::data::action_bindShop": "Binding shop",
  "user-guidance::data::action_email": "inbox",
  "user-guidance::data::action_newGoods": "New Product",
  "user-guidance::data::action_newOrder": "New orders for sale",
  "user-guidance::data::action_orderList": "Order List",
  "user-guidance::data::action_sync": "One-button synchronization",
  "user-guidance::data::ad_cost": "Advertising spending",
  "user-guidance::data::ad_ROI": "Advertising ROI",
  "user-guidance::data::ad_sales": "Advertising sales",
  "user-guidance::data::ad_title": "Today advertising data",
  "user-guidance::data::analysis_bar": "Turnover",
  "user-guidance::data::analysis_line": "Customer price",
  "user-guidance::data::analysis_orderDate": "Order payment date",
  "user-guidance::data::analysis_shopName": "Store Name",
  "user-guidance::data::analysis_title": "sales analysis",
  "user-guidance::data::close_tip": "Are you sure to close the guide function, can not be opened again after closing Proceed with caution",
  "user-guidance::data::order_button": "Ship",
  "user-guidance::data::order_more": "see more",
  "user-guidance::data::order_operation": "operating",
  "user-guidance::data::order_orderNo": "Order Number Platform",
  "user-guidance::data::order_payTime": "order time",
  "user-guidance::data::order_payTotalAmount": "order amount",
  "user-guidance::data::order_quantity": "commodity",
  "user-guidance::data::order_sourceNo": "Shop Order Number",
  "user-guidance::data::order_title": "Orders to be shipped",
  "user-guidance::data::sales_title": "Today's Business Daily",
  "user-guidance::data::sales::sales_order_title": "Orders",
  "user-guidance::data::sales::sales_sale_title": "Sales",
  "user-guidance::data::sales::sales_saleOrder_title": "Pending sale orders",
  "user-guidance::data::sales::sales_sendOrder_title": "Orders to be shipped",
  "user-guidance::dialog_button_auth": "Authorize now",
  "user-guidance::dialog_button_noShow": "never show again",
  "user-guidance::guide::adAccount_button": "Set up a Facebook account",
  "user-guidance::guide::adAccount_text": "Set ad account",
  "user-guidance::guide::adAccount_tip": "We'll pull advertising data, providing Facebook, Google advertising data analysis",
  "user-guidance::guide::adAccount_title": "Advertising account settings",
  "user-guidance::guide::bindShop_button": "Binding shop",
  "user-guidance::guide::bindShop_text": "You're binding a shop operator",
  "user-guidance::guide::bindShop_tip": "After binding shop, the system will auto-complete data synchronization, multi-shop (goods orders, after-sale) unified management, multi-dimensional business data analysis",
  "user-guidance::guide::bindShop_title": "Shop Binding",
  "user-guidance::guide::close": "Closed guidance",
  "user-guidance::guide::email_button": "Set-Mailbox",
  "user-guidance::guide::email_text": "Setting sales customer service mailbox",
  "user-guidance::guide::email_tip": "After setting the mailbox, the system can be set up for your after-sales service system, automatically identify your e-mail orders, efficient service.",
  "user-guidance::guide::email_title": "Sale mailbox settings",
  "user-guidance::guide::logistics_button": "Binding logistics providers",
  "user-guidance::guide::logistics_text": "Binding a cross-border logistics providers",
  "user-guidance::guide::logistics_tip": "Binding logistics providers, the system can intelligently recommend solutions for your transportation and logistics providers to connect your system fast delivery",
  "user-guidance::guide::logistics_title": "Binding logistics providers",
  "user-guidance::guide::paySetting_button": "Setting payment channels",
  "user-guidance::guide::paySetting_text": "Set up payment accounts",
  "user-guidance::guide::paySetting_tip": "When the shop order generation aftermarket demand a refund, your refund can operate directly",
  "user-guidance::guide::paySetting_title": "Payment settings",
  "user-guidance::guide::title": "Hello, super store BI journey worse {step} steps to go!",
  "user-guidance::text": "Super-wide electricity supplier link digital platforms",
  "user-guidance::title": "Hello! Welcome to the super store BI!",
  "VALID_REQUEST_ERROR": "Illegal permission request",
  "VALIDATE_CODE_WRONG": "Verification code error",
  "VERIFY_JWT_ERROR": "Failed to parse token",
  "VOCABULARY_EXIST": "Words corresponding to the front end of an existing",
  "WECHAR_ALREADY_REGISTERED": "This micro-channel has been registered, registration need not be repeated",
  "WECHAT_UNIONID_GET_FAIL": "Please Algobuy public concern No.",
  "work-order::auth_tooltip": "E-mail can be set up after-sales customer service work order presented [Overview]",
  "work-order::emailType_title": "Mail type accounting",
  "work-order::notRecieve_title": "Unanswered rate",
  "work-order::notRecieve_tooltip": "The formula is: Unanswered number / number of messages received",
  "work-order::notReply_title": "No Replies",
  "work-order::notReply_tooltip": "As of the current message is received no reply number",
  "work-order::recieve_title": "Number of messages received",
  "work-order::recieve_tooltip": "The total number of incoming messages",
  "work-order::recieveDate": "Receive e-mail time",
  "work-order::recieveEmail_title": "Number of messages received",
  "work-order::replier::table": "Reply people",
  "work-order::replier::table_12reply": "Replies within 12 hours",
  "work-order::replier::table_24reply": "12-24 hours Replies",
  "work-order::replier::table_48reply": "24-48 hours Replies",
  "work-order::replier::table_email": "Number of messages received",
  "work-order::replier::table_name": "Name of reply",
  "work-order::replier::table_notReply": "No Replies",
  "work-order::replier::table_out48reply": "Super 48 hours Replies",
  "work-order::replier::table_reply": "Replies",
  "work-order::shopName": "Store Name",
  "work-order::station": "Sites",
  "work-order::station::table_name": "Store Name",
  "work-order::user_title": "Customer complaints users",
  "work-order::user_tooltip": "The message was received belongs to heavy users",
  "system::document::title": "More professional and efficient cross-border electricity supplier operating a full link data platform",
  "after-sales::in-box::hand_reply": "Replied manual",
  "after-sales::in-box::more": "More",
  "after-sales::in-box::set_email_status": "After setting the message status will change to Replied",
  "after-sales::in-box::set_email_status_confirm": "Manually set to determine the mail has been restored?",
  "dashboard-bi::person-board::click_top_right": "Top right, click [New] to create a custom report it",
  "dashboard-bi::person-board::empty_board": "No chart",
  "dashboard-bi::person-board:add": "Adding to see the version",
  "dashboard-bi::person-board:create": "New Custom Report",
  "dashboard-bi::person-board:delete_tip": "Kanban sure to delete it?",
  "dashboard-bi::person-board:edit": "Editor read version",
  "dashboard-bi::person-board:select_holder": "Please select Kanban",
  "ocean-bi:供应链分析": "Supply chain analysis",
  "ocean-bi:商户ID": "Merchant ID",
  "ocean-bi:工单分析报表": "Work Order Analysis Report",
  "ocean-bi:广告分析": "Advertising Analytics",
  "ocean-bi:店铺ID": "Store ID",
  "ocean-bi:营销分析报表": "Marketing Analysis Report",
  "ocean-bi:退货分析报表": "Returns Analysis Report",
  "ocean-bi:邮件ID": "Mail ID",
  "ocean-bi:销售分析报表": "Sales Analysis Report",
  "stores::products-info::copy_sku": "Copy SKU",
  "system::rbac::phone_invited": "The invited user's mobile phone number or email",
  "system::rbac::phone_tips_wrong": "Phone number or E-mail format error",
  "system::rbac::phone_tooltip": "Users need to be invited as registered users, if not priority registration please complete the registration steps",
  "system::tip::accept_file": "Only supports [file] {accept}",
  "system::tip::fileSize_limit": "Only supports [M {fileSize}] File size",
  "system::tip::limit": "Upload up files {limit}",
  " dashboard-bi::edit-report::click_or_drop_dimension": "双击或拖拽维度字段到这里",
  "after-sales::after-sales-set::after_sales_reason_init": "The reason the introduction of after-sale system",
  "after-sales::email-setting::email_sort_init": "Mail classification system introduced",
  "after-sales::email-setting::email_tag_init": "Introduced into the system Mailing Labels",
  "customer::customer-manager::level_init": "Customers rating system introduced",
  "customer::customer-manager::tag_init": "Customers tag system introduced",
  "dashboard-bi::person-board::dimension_holder\r\n": "Please select Linkage dimension",
  "dashboard-bi::person-board::select_dimension\r\n": "Choose linkage dimensions:",
  "ocean-bi:浏览网站": "Visit the website",
  "order-export:主订单物流状态": "Order Logistics main state",
  "order-export:创建时间": "Created",
  "order-export:售后状态": "Aftermarket state",
  "order-export:商品SKU": "Product SKU",
  "order-export:商品SPU": "Commodity SPU",
  "order-export:商品单价": "Commodity price",
  "order-export:商品名称": "product name",
  "order-export:商品属性": "Commercial Property",
  "order-export:商品数量": "amount of goods",
  "order-export:国家": "country",
  "order-export:地址1": "Address 1",
  "order-export:地址2": "Address 2",
  "order-export:城市": "city",
  "order-export:子订单物流状态": "Order Logistics sub-state",
  "order-export:子订单金额": "Sub-order amount",
  "order-export:客户": "client",
  "order-export:平台": "platform",
  "order-export:平台订单编号": "Order Number Platform",
  "order-export:店铺": "Shop",
  "order-export:店铺订单编号": "Shop Order Number",
  "order-export:支付方式": "payment method",
  "order-export:支付时间": "Payment time",
  "order-export:支付状态": "Payment status",
  "order-export:物流单号": "shipment number",
  "order-export:物流商": "Logistics providers",
  "order-export:省": "province",
  "order-export:联系电话": "contact number",
  "order-export:联系邮箱": "Contact E-mail",
  "order-export:订单优惠金额": "Order discount amount",
  "order-export:订单状态": "Order Status",
  "order-export:订单税费": "Orders taxes",
  "order-export:订单邮费": "Order Free",
  "order-export:订单金额(USD)": "Order amount (USD)",
  "order-export:运费方案": "Freight scheme",
  "order-export:邮编": "Zip Code",
  "product-export:SKU": "SKU",
  "product-export:SPU": "SPU",
  "product-export:供应商": "supplier",
  "product-export:原价": "Price",
  "product-export:售价": "Selling price",
  "product-export:商品名称": "product name",
  "product-export:商品库存": "Commodity stocks",
  "product-export:商品类目": "Product categories",
  "product-export:状态": "status",
  "product-manager::init_cate": "The introduction of systems product category",
  "stockInOut-export:SKU": "SKU",
  "stockInOut-export:sku属性": "sku property",
  "stockInOut-export:业务类型": "business type",
  "stockInOut-export:仓库类型": "Warehouse type",
  "stockInOut-export:创建人": "founder",
  "stockInOut-export:创建时间": "Created",
  "stockInOut-export:单号": "Single number",
  "stockInOut-export:商品名称": "product name",
  "stockInOut-export:商品类目": "Product categories",
  "stockInOut-export:审核人": "Reviewer",
  "stockInOut-export:审核时间": "Review time",
  "stockInOut-export:总价": "Total price",
  "stockInOut-export:数量": "Quantity",
  "system::common::btn::selecAll": "select all",
  "system::common::editorHeader-table::btn": "Edit Header",
  "system::common::editorHeader-table::errorTip": "Please select at least five header fields",
  "system::common::editorHeader-table::tip": "Please select the fields shown in the table, drag exchange order",
  "system::common::editorHeader-table::title": "Header Set",
  "system::common::tips::quick_setting": "Use the system default data can be quickly set up",
  "system::rbac::menu_select": "Check the menu function",
  "after-sales::after-sale-list::detail_empty_refuntAmount": "The total amount of the refund can not be 0",
  "after-sales::after-sale-list::detail_apply_refund_tips": "Determining a refund?",
  "after-sales::after-sale-list::detail_refund_tips": "Determining a refund?",
  "after-sales::after-sale-list::detail_reject_tips": "OK dismissed?",
  "dashboard-bi::edit-report::calcul_type_add": "plus",
  "dashboard-bi::edit-report::calcul_type_cut": "Less",
  "dashboard-bi::edit-report::calcul_type_del": "delete",
  "dashboard-bi::edit-report::calcul_type_except": "except",
  "dashboard-bi::edit-report::calcul_type_ride": "Multiply",
  "dashboard-bi::edit-report::cancel_input": "Cancel input",
  "dashboard-bi::edit-report::count": "statistics",
  "dashboard-bi::edit-report::drilling": "Drill",
  "dashboard-bi::edit-report::link": "Linkage",
  "dashboard-bi::edit-report::set_linkage": "Set linkage",
  "dashboard-bi::edit-report::total": "total",
  "dashboard-bi::person-board::board_download_long": "Download the report takes a long time, check the mailbox, or click to download again later",
  "dashboard-bi::person-board::board_filter": "Screening Report",
  "dashboard-bi::person-board::board_sended": "Has been sent, please check your mailbox",
  "dashboard-bi::person-board::board_send_tip_title": "Send the report tips",
  "dashboard-bi::person-board::board_send_wait": "Detailed report is being sent to your e-mail, please wait",
  "dashboard-bi::person-board::click_to_default": "Click to restore the original state linkage",
  "dashboard-bi::person-board::detail_report_download": "Detail Report Download",
  "dashboard-bi::person-board::holder_number": "Please key in numbers",
  "dashboard-bi::person-board::last_time": "Last updated",
  "dashboard-bi::person-board::report_delete": "Delete Report",
  "dashboard-bi::person-board::report_download": "Download report",
  "dashboard-bi::person-board::report_edit": "Report Editor",
  "dashboard-bi::person-board::un_link": "No linkage selection",
  "dashboard-bi::person-board::_number_verify": "Digital format is incorrect",
  "ocean-bi:shoplusBI-供应链分析": "shoplusBI- supply chain analysis",
  "ocean-bi:shoplusBI-工单分析": "shoplusBI- work order analysis",
  "ocean-bi:shoplusBI-广告分析": "shoplusBI- advertising analysis",
  "ocean-bi:shoplusBI-营销分析": "shoplusBI- marketing analysis",
  "ocean-bi:shoplusBI-退款分析": "shoplusBI- refund Analysis",
  "ocean-bi:shoplusBI-销售分析": "shoplusBI- Sales Analysis",
  "ocean-query:创建订单": "Create Order",
  "ocean-query:加购": "Plus purchase",
  "ocean-query:支付成功": "payment successful",
  "ocean-query:浏览网站": "Visit the website",
  "ocean-query:进入结算页": "Billing page",
  "stores::products-info::edit_safe_sku": "Setting safety stock",
  "stores::products-info::edit_sku_title": "Batch setting safety stock",
  "stores::products-info::edit_supplier_title": "Batch Set Suppliers",
  "system::common::text::explain_tip": "Explanation",
  "dashboard-bi::edit-report::Illegal_computation_operation": "Illegal computing operation",
  "dashboard-bi::edit-report::pleace_count_select": "Please select the calculation mode",
  "dashboard-bi::edit-report::select_input": "Please select the field",
  "dashboard-bi::edit-report::chart_bar_report": "Column Chart",
  "dashboard-bi::edit-report::chart_bar_report_tip": "A multi-dimension or two dimensions of a numerical value",
  "dashboard-bi::edit-report::chart_funnel_report": "Funnel plot",
  "dashboard-bi::edit-report::chart_funnel_report_tip": "Value of 1 or 0 Dimension 1 Dimension multivalued",
  "dashboard-bi::edit-report::chart_index_report": "Index card",
  "dashboard-bi::edit-report::chart_index_report_tip": "Value 0 Dimension 1",
  "dashboard-bi::edit-report::chart_lineAndBar_report": "Histogram polyline",
  "dashboard-bi::edit-report::chart_lineAndBar_report_tip": "1 2 Dimension values",
  "dashboard-bi::edit-report::chart_line_report": "line chart",
  "dashboard-bi::edit-report::chart_line_report_tip": "A multi-dimension or two dimensions of a numerical value",
  "dashboard-bi::edit-report::chart_pie_report": "Pie",
  "dashboard-bi::edit-report::chart_pie_report_tip": "1 Dimension 1 value",
  "dashboard-bi::edit-report::chart_table": "form",
  "dashboard-bi::edit-report::chart_table_tip": "Any dimensions and values",
  "dashboard-bi::edit-report::please_select_dim_or_value": "Please select the dimension or value"
}
